import React, { useCallback, useState, lazy, Suspense } from 'react';
import {
  Button,
  TextInput,
  NumberInput,
  Select,
  SelectItem,
  Checkbox,
  DataTable,
  TableRow,
  TableHead,
  TableHeader,
  TableContainer,
  TableCell,
  Table,
  TableBody,
  TableToolbar,
  TableToolbarContent,
} from 'carbon-components-react';

import Collapsible from 'react-collapsible';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import { Tooltip as ReactTooltip } from "react-tooltip";


import { safeLoad, getDivHeight, jsonToYaml, updateStyle, updateStyle2, validateField, toggleDescription } from '../../helpers';

const PoliciesauthorizationDeleteModal = lazy(() => import('./policiesauthorizationDeleteModal'));
const PoliciesauthorizationAdd = lazy(() => import('./policiesauthorizationAdd'));
const PoliciesauthorizationEdit = lazy(() => import('./policiesauthorizationEdit'));
const PoliciesauthorizationmethodsDeleteModal = lazy(() => import('./policiesauthorizationmethodsDeleteModal'));
const PoliciesauthorizationmethodsAdd = lazy(() => import('./policiesauthorizationmethodsAdd'));
const PoliciesauthorizationmethodsEdit = lazy(() => import('./policiesauthorizationmethodsEdit'));
const PoliciesauthorizationpathsDeleteModal = lazy(() => import('./policiesauthorizationpathsDeleteModal'));
const PoliciesauthorizationpathsAdd = lazy(() => import('./policiesauthorizationpathsAdd'));
const PoliciesauthorizationpathsEdit = lazy(() => import('./policiesauthorizationpathsEdit'));
const PoliciescontentInjectionDeleteModal = lazy(() => import('./policiescontent_injectionDeleteModal'));
const PoliciescontentInjectionAdd = lazy(() => import('./policiescontent_injectionAdd'));
const PoliciescontentInjectionEdit = lazy(() => import('./policiescontent_injectionEdit'));
const PoliciescontentInjectionpathsDeleteModal = lazy(() => import('./policiescontent_injectionpathsDeleteModal'));
const PoliciescontentInjectionpathsAdd = lazy(() => import('./policiescontent_injectionpathsAdd'));
const PoliciescontentInjectionpathsEdit = lazy(() => import('./policiescontent_injectionpathsEdit'));
const PoliciescorsDeleteModal = lazy(() => import('./policiescorsDeleteModal'));
const PoliciescorsAdd = lazy(() => import('./policiescorsAdd'));
const PoliciescorsEdit = lazy(() => import('./policiescorsEdit'));
const PoliciescorspathsDeleteModal = lazy(() => import('./policiescorspathsDeleteModal'));
const PoliciescorspathsAdd = lazy(() => import('./policiescorspathsAdd'));
const PoliciescorspathsEdit = lazy(() => import('./policiescorspathsEdit'));
const PoliciescorspolicyallowHeadersDeleteModal = lazy(() => import('./policiescorspolicyallow_headersDeleteModal'));
const PoliciescorspolicyallowHeadersAdd = lazy(() => import('./policiescorspolicyallow_headersAdd'));
const PoliciescorspolicyallowHeadersEdit = lazy(() => import('./policiescorspolicyallow_headersEdit'));
const PoliciescorspolicyallowMethodsDeleteModal = lazy(() => import('./policiescorspolicyallow_methodsDeleteModal'));
const PoliciescorspolicyallowMethodsAdd = lazy(() => import('./policiescorspolicyallow_methodsAdd'));
const PoliciescorspolicyallowMethodsEdit = lazy(() => import('./policiescorspolicyallow_methodsEdit'));
const PoliciescorspolicyallowOriginsDeleteModal = lazy(() => import('./policiescorspolicyallow_originsDeleteModal'));
const PoliciescorspolicyallowOriginsAdd = lazy(() => import('./policiescorspolicyallow_originsAdd'));
const PoliciescorspolicyallowOriginsEdit = lazy(() => import('./policiescorspolicyallow_originsEdit'));
const PoliciescorspolicyexposeHeadersDeleteModal = lazy(() => import('./policiescorspolicyexpose_headersDeleteModal'));
const PoliciescorspolicyexposeHeadersAdd = lazy(() => import('./policiescorspolicyexpose_headersAdd'));
const PoliciescorspolicyexposeHeadersEdit = lazy(() => import('./policiescorspolicyexpose_headersEdit'));
const PolicieshttpTransformationspostauthnDeleteModal = lazy(() => import('./policieshttp_transformationspostauthnDeleteModal'));
const PolicieshttpTransformationspostauthnAdd = lazy(() => import('./policieshttp_transformationspostauthnAdd'));
const PolicieshttpTransformationspostauthnEdit = lazy(() => import('./policieshttp_transformationspostauthnEdit'));
const PolicieshttpTransformationspostauthnauthenticationMechanismsDeleteModal = lazy(() => import('./policieshttp_transformationspostauthnauthentication_mechanismsDeleteModal'));
const PolicieshttpTransformationspostauthnauthenticationMechanismsAdd = lazy(() => import('./policieshttp_transformationspostauthnauthentication_mechanismsAdd'));
const PolicieshttpTransformationspostauthnauthenticationMechanismsEdit = lazy(() => import('./policieshttp_transformationspostauthnauthentication_mechanismsEdit'));
const PolicieshttpTransformationspostaznDeleteModal = lazy(() => import('./policieshttp_transformationspostaznDeleteModal'));
const PolicieshttpTransformationspostaznAdd = lazy(() => import('./policieshttp_transformationspostaznAdd'));
const PolicieshttpTransformationspostaznEdit = lazy(() => import('./policieshttp_transformationspostaznEdit'));
const PolicieshttpTransformationspostaznpathsDeleteModal = lazy(() => import('./policieshttp_transformationspostaznpathsDeleteModal'));
const PolicieshttpTransformationspostaznpathsAdd = lazy(() => import('./policieshttp_transformationspostaznpathsAdd'));
const PolicieshttpTransformationspostaznpathsEdit = lazy(() => import('./policieshttp_transformationspostaznpathsEdit'));
const PolicieshttpTransformationspreaznDeleteModal = lazy(() => import('./policieshttp_transformationspreaznDeleteModal'));
const PolicieshttpTransformationspreaznAdd = lazy(() => import('./policieshttp_transformationspreaznAdd'));
const PolicieshttpTransformationspreaznEdit = lazy(() => import('./policieshttp_transformationspreaznEdit'));
const PolicieshttpTransformationspreaznpathsDeleteModal = lazy(() => import('./policieshttp_transformationspreaznpathsDeleteModal'));
const PolicieshttpTransformationspreaznpathsAdd = lazy(() => import('./policieshttp_transformationspreaznpathsAdd'));
const PolicieshttpTransformationspreaznpathsEdit = lazy(() => import('./policieshttp_transformationspreaznpathsEdit'));
const PolicieshttpTransformationsrequestDeleteModal = lazy(() => import('./policieshttp_transformationsrequestDeleteModal'));
const PolicieshttpTransformationsrequestAdd = lazy(() => import('./policieshttp_transformationsrequestAdd'));
const PolicieshttpTransformationsrequestEdit = lazy(() => import('./policieshttp_transformationsrequestEdit'));
const PolicieshttpTransformationsrequestpathsDeleteModal = lazy(() => import('./policieshttp_transformationsrequestpathsDeleteModal'));
const PolicieshttpTransformationsrequestpathsAdd = lazy(() => import('./policieshttp_transformationsrequestpathsAdd'));
const PolicieshttpTransformationsrequestpathsEdit = lazy(() => import('./policieshttp_transformationsrequestpathsEdit'));
const PolicieshttpTransformationsresponseDeleteModal = lazy(() => import('./policieshttp_transformationsresponseDeleteModal'));
const PolicieshttpTransformationsresponseAdd = lazy(() => import('./policieshttp_transformationsresponseAdd'));
const PolicieshttpTransformationsresponseEdit = lazy(() => import('./policieshttp_transformationsresponseEdit'));
const PolicieshttpTransformationsresponsepathsDeleteModal = lazy(() => import('./policieshttp_transformationsresponsepathsDeleteModal'));
const PolicieshttpTransformationsresponsepathsAdd = lazy(() => import('./policieshttp_transformationsresponsepathsAdd'));
const PolicieshttpTransformationsresponsepathsEdit = lazy(() => import('./policieshttp_transformationsresponsepathsEdit'));
const PolicieshttpTransformationssecretsDeleteModal = lazy(() => import('./policieshttp_transformationssecretsDeleteModal'));
const PolicieshttpTransformationssecretsAdd = lazy(() => import('./policieshttp_transformationssecretsAdd'));
const PolicieshttpTransformationssecretsEdit = lazy(() => import('./policieshttp_transformationssecretsEdit'));
const PoliciesrateLimitingDeleteModal = lazy(() => import('./policiesrate_limitingDeleteModal'));
const PoliciesrateLimitingAdd = lazy(() => import('./policiesrate_limitingAdd'));
const PoliciesrateLimitingEdit = lazy(() => import('./policiesrate_limitingEdit'));
const PoliciesrateLimitingmethodsDeleteModal = lazy(() => import('./policiesrate_limitingmethodsDeleteModal'));
const PoliciesrateLimitingmethodsAdd = lazy(() => import('./policiesrate_limitingmethodsAdd'));
const PoliciesrateLimitingmethodsEdit = lazy(() => import('./policiesrate_limitingmethodsEdit'));
const PoliciesrateLimitingpathsDeleteModal = lazy(() => import('./policiesrate_limitingpathsDeleteModal'));
const PoliciesrateLimitingpathsAdd = lazy(() => import('./policiesrate_limitingpathsAdd'));
const PoliciesrateLimitingpathsEdit = lazy(() => import('./policiesrate_limitingpathsEdit'));
const PolicieswafrequestMatchDeleteModal = lazy(() => import('./policieswafrequest_matchDeleteModal'));
const PolicieswafrequestMatchAdd = lazy(() => import('./policieswafrequest_matchAdd'));
const PolicieswafrequestMatchEdit = lazy(() => import('./policieswafrequest_matchEdit'));


const handleChange = () =>{
    var yamlText = window.iagyaml;

    var json = {};

    if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
    }

    var newElem = {};
    var newhttp_transformations = {};
    newhttp_transformations["postauthn"] = policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn;
    newhttp_transformations["postazn"] = policies_http_transformations_postaznrowData.policies_http_transformations_postazn;
    newhttp_transformations["preazn"] = policies_http_transformations_preaznrowData.policies_http_transformations_preazn;
    newhttp_transformations["request"] = policies_http_transformations_requestrowData.policies_http_transformations_request;
    newhttp_transformations["response"] = policies_http_transformations_responserowData.policies_http_transformations_response;
    newhttp_transformations["secrets"] = policies_http_transformations_secretsrowData.policies_http_transformations_secrets;
    newElem["http_transformations"] = newhttp_transformations;
    var newwaf = {};
    var newconfiguration = {};
    if(document.getElementById("policies_waf_configuration_content_id").value.endsWith(":") !== true) {
    newconfiguration["content"] = document.getElementById("policies_waf_configuration_content_id").value;
    }
    newconfiguration["type"] = document.getElementById("policies_waf_configuration_type_id").value;
    newwaf["configuration"] = newconfiguration;
    var newrules = {};
    if(document.getElementById("policies_waf_rules_content_id").value.endsWith(":") !== true) {
    newrules["content"] = document.getElementById("policies_waf_rules_content_id").value;
    }
    newrules["type"] = document.getElementById("policies_waf_rules_type_id").value;
    newwaf["rules"] = newrules;
    newwaf["request_match"] = policies_waf_request_matchrowData.policies_waf_request_match;
    newElem["waf"] = newwaf;
    newElem["postauthn"] = policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn;
    newElem["authorization"] = policies_authorizationrowData.policies_authorization;
    newElem["postazn"] = policies_http_transformations_postaznrowData.policies_http_transformations_postazn;
    newElem["rate_limiting"] = policies_rate_limitingrowData.policies_rate_limiting;
    newElem["content_injection"] = policies_content_injectionrowData.policies_content_injection;
    newElem["preazn"] = policies_http_transformations_preaznrowData.policies_http_transformations_preazn;
    newElem["request"] = policies_http_transformations_requestrowData.policies_http_transformations_request;
    newElem["response"] = policies_http_transformations_responserowData.policies_http_transformations_response;
    newElem["secrets"] = policies_http_transformations_secretsrowData.policies_http_transformations_secrets;
    newElem["cors"] = policies_corsrowData.policies_cors;
    newElem["request_match"] = policies_waf_request_matchrowData.policies_waf_request_match;
    json["policies"] = newElem;

    var yamlop = jsonToYaml(json);
    window.iagyaml = yamlop;
};

  const closeAdd = (idPrefix) => {

      if(idPrefix === undefined) idPrefix = "";

      updateStyle("policies_div" + idPrefix, "display", "block");
      document.getElementById("policies_tab" + idPrefix).style.display = "flex";

  };

const policies_authorizationheaderData = [
    {
    header: 'Action',
    key: 'action',
  },
{
    header: 'Host',
    key: 'host',
  },
{
    header: 'Name',
    key: 'name',
  },
{
    header: 'Rule',
    key: 'rule',
  },

];

const policies_authorizationrowData = {policies_authorization: []};

const policies_authorizationhandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_authorization_action_id" + idPrefix).value = "";
    document.getElementById("policies_authorization_host_id" + idPrefix).value = "";
    document.getElementById("policies_authorization_name_id" + idPrefix).value = "";
    document.getElementById("policies_authorization_obligation_oidc_acr_values_id" + idPrefix).value = "";
    document.getElementById("policies_authorization_obligation_oidc_max_age_id" + idPrefix).value = "";
    document.getElementById("policies_authorization_obligation_oidc_prompt_id" + idPrefix).value = "";
    document.getElementById("policies_authorization_obligation_redirect_url_id" + idPrefix).value = "";
    document.getElementById("policies_authorization_rule_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicies_authorizationPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_authorization_methodsheaderData = [
    {
    header: 'Method',
    key: 'methods',
  },

];

const policies_authorization_methodsrowData = {policies_authorization_methods: []};

const policies_authorization_methodshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_authorization_methods_methods_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpoliciesauthorization_methodsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_authorization_pathsheaderData = [
    {
    header: 'Path',
    key: 'paths',
  },

];

const policies_authorization_pathsrowData = {policies_authorization_paths: []};

const policies_authorization_pathshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_authorization_paths_paths_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpoliciesauthorization_pathsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_content_injectionheaderData = [
    {
    header: 'Content',
    key: 'content',
  },
{
    header: 'Full Line Match',
    key: 'full_line_match',
  },
{
    header: 'Location',
    key: 'location',
  },
{
    header: 'Name',
    key: 'name',
  },
{
    header: 'Replace Match',
    key: 'replace_match',
  },

];

const policies_content_injectionrowData = {policies_content_injection: []};

const policies_content_injectionhandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_content_injection_content_id" + idPrefix).value = "";
    document.getElementById("policies_content_injection_full_line_match_id" + idPrefix).value = "";
    document.getElementById("policies_content_injection_location_id" + idPrefix).value = "";
    document.getElementById("policies_content_injection_name_id" + idPrefix).value = "";
    document.getElementById("policies_content_injection_replace_match_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicies_content_injectionPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_content_injection_pathsheaderData = [
    {
    header: 'Path',
    key: 'paths',
  },

];

const policies_content_injection_pathsrowData = {policies_content_injection_paths: []};

const policies_content_injection_pathshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_content_injection_paths_paths_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpoliciescontent_injection_pathsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_corsheaderData = [
    {
    header: 'Host',
    key: 'host',
  },
{
    header: 'Method',
    key: 'method',
  },
{
    header: 'Name',
    key: 'name',
  },

];

const policies_corsrowData = {policies_cors: []};

const policies_corshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_cors_host_id" + idPrefix).value = "";
    document.getElementById("policies_cors_method_id" + idPrefix).value = "";
    document.getElementById("policies_cors_name_id" + idPrefix).value = "";
    document.getElementById("policies_cors_policy_allow_credentials_id" + idPrefix).value = "";
    document.getElementById("policies_cors_policy_handle_pre_flight_id" + idPrefix).value = "";
    document.getElementById("policies_cors_policy_max_age_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicies_corsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_cors_pathsheaderData = [
    {
    header: 'Path',
    key: 'paths',
  },

];

const policies_cors_pathsrowData = {policies_cors_paths: []};

const policies_cors_pathshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_cors_paths_paths_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpoliciescors_pathsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_cors_policy_allow_headersheaderData = [
    {
    header: 'Header',
    key: 'allow_headers',
  },

];

const policies_cors_policy_allow_headersrowData = {policies_cors_policy_allow_headers: []};

const policies_cors_policy_allow_headershandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_cors_policy_allow_headers_allow_headers_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpoliciescorspolicy_allow_headersPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_cors_policy_allow_methodsheaderData = [
    {
    header: 'Method',
    key: 'allow_methods',
  },

];

const policies_cors_policy_allow_methodsrowData = {policies_cors_policy_allow_methods: []};

const policies_cors_policy_allow_methodshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_cors_policy_allow_methods_allow_methods_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpoliciescorspolicy_allow_methodsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_cors_policy_allow_originsheaderData = [
    {
    header: 'Origin',
    key: 'allow_origins',
  },

];

const policies_cors_policy_allow_originsrowData = {policies_cors_policy_allow_origins: []};

const policies_cors_policy_allow_originshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_cors_policy_allow_origins_allow_origins_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpoliciescorspolicy_allow_originsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_cors_policy_expose_headersheaderData = [
    {
    header: 'Header',
    key: 'expose_headers',
  },

];

const policies_cors_policy_expose_headersrowData = {policies_cors_policy_expose_headers: []};

const policies_cors_policy_expose_headershandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_cors_policy_expose_headers_expose_headers_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpoliciescorspolicy_expose_headersPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_http_transformations_postauthnheaderData = [
    {
    header: 'Host',
    key: 'host',
  },
{
    header: 'Name',
    key: 'name',
  },
{
    header: 'Rule',
    key: 'rule',
  },

];

const policies_http_transformations_postauthnrowData = {policies_http_transformations_postauthn: []};

const policies_http_transformations_postauthnhandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_http_transformations_postauthn_host_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_postauthn_name_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_postauthn_rule_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicieshttp_transformations_postauthnPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_http_transformations_postauthn_authentication_mechanismsheaderData = [
    {
    header: 'Authentication Mechanisms',
    key: 'authentication_mechanisms',
  },

];

const policies_http_transformations_postauthn_authentication_mechanismsrowData = {policies_http_transformations_postauthn_authentication_mechanisms: []};

const policies_http_transformations_postauthn_authentication_mechanismshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_http_transformations_postauthn_authentication_mechanisms_authentication_mechanisms_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicieshttp_transformationspostauthn_authentication_mechanismsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_http_transformations_postaznheaderData = [
    {
    header: 'Host',
    key: 'host',
  },
{
    header: 'Method',
    key: 'method',
  },
{
    header: 'Name',
    key: 'name',
  },
{
    header: 'Rule',
    key: 'rule',
  },

];

const policies_http_transformations_postaznrowData = {policies_http_transformations_postazn: []};

const policies_http_transformations_postaznhandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_http_transformations_postazn_host_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_postazn_method_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_postazn_name_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_postazn_rule_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicieshttp_transformations_postaznPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_http_transformations_postazn_pathsheaderData = [
    {
    header: 'Path',
    key: 'paths',
  },

];

const policies_http_transformations_postazn_pathsrowData = {policies_http_transformations_postazn_paths: []};

const policies_http_transformations_postazn_pathshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_http_transformations_postazn_paths_paths_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicieshttp_transformationspostazn_pathsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_http_transformations_preaznheaderData = [
    {
    header: 'Host',
    key: 'host',
  },
{
    header: 'Method',
    key: 'method',
  },
{
    header: 'Name',
    key: 'name',
  },
{
    header: 'Rule',
    key: 'rule',
  },

];

const policies_http_transformations_preaznrowData = {policies_http_transformations_preazn: []};

const policies_http_transformations_preaznhandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_http_transformations_preazn_host_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_preazn_method_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_preazn_name_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_preazn_rule_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicieshttp_transformations_preaznPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_http_transformations_preazn_pathsheaderData = [
    {
    header: 'Path',
    key: 'paths',
  },

];

const policies_http_transformations_preazn_pathsrowData = {policies_http_transformations_preazn_paths: []};

const policies_http_transformations_preazn_pathshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_http_transformations_preazn_paths_paths_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicieshttp_transformationspreazn_pathsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_http_transformations_requestheaderData = [
    {
    header: 'Host',
    key: 'host',
  },
{
    header: 'Method',
    key: 'method',
  },
{
    header: 'Name',
    key: 'name',
  },
{
    header: 'Rule',
    key: 'rule',
  },

];

const policies_http_transformations_requestrowData = {policies_http_transformations_request: []};

const policies_http_transformations_requesthandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_http_transformations_request_host_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_request_method_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_request_name_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_request_rule_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicieshttp_transformations_requestPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_http_transformations_request_pathsheaderData = [
    {
    header: 'Path',
    key: 'paths',
  },

];

const policies_http_transformations_request_pathsrowData = {policies_http_transformations_request_paths: []};

const policies_http_transformations_request_pathshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_http_transformations_request_paths_paths_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicieshttp_transformationsrequest_pathsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_http_transformations_responseheaderData = [
    {
    header: 'Host',
    key: 'host',
  },
{
    header: 'Method',
    key: 'method',
  },
{
    header: 'Name',
    key: 'name',
  },
{
    header: 'Rule',
    key: 'rule',
  },

];

const policies_http_transformations_responserowData = {policies_http_transformations_response: []};

const policies_http_transformations_responsehandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_http_transformations_response_host_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_response_method_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_response_name_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_response_rule_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicieshttp_transformations_responsePage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_http_transformations_response_pathsheaderData = [
    {
    header: 'Path',
    key: 'paths',
  },

];

const policies_http_transformations_response_pathsrowData = {policies_http_transformations_response_paths: []};

const policies_http_transformations_response_pathshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_http_transformations_response_paths_paths_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicieshttp_transformationsresponse_pathsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_http_transformations_secretsheaderData = [
    {
    header: 'Name',
    key: 'name',
  },
{
    header: 'Value',
    key: 'value',
  },

];

const policies_http_transformations_secretsrowData = {policies_http_transformations_secrets: []};

const policies_http_transformations_secretshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_http_transformations_secrets_name_id" + idPrefix).value = "";
    document.getElementById("policies_http_transformations_secrets_value_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicieshttp_transformations_secretsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_rate_limitingheaderData = [
    {
    header: 'Name',
    key: 'name',
  },
{
    header: 'Rule',
    key: 'rule',
  },

];

const policies_rate_limitingrowData = {policies_rate_limiting: []};

const policies_rate_limitinghandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_rate_limiting_name_id" + idPrefix).value = "";
    document.getElementById("policies_rate_limiting_rule_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicies_rate_limitingPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_rate_limiting_methodsheaderData = [
    {
    header: 'Method',
    key: 'methods',
  },

];

const policies_rate_limiting_methodsrowData = {policies_rate_limiting_methods: []};

const policies_rate_limiting_methodshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_rate_limiting_methods_methods_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpoliciesrate_limiting_methodsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_rate_limiting_pathsheaderData = [
    {
    header: 'Path',
    key: 'paths',
  },

];

const policies_rate_limiting_pathsrowData = {policies_rate_limiting_paths: []};

const policies_rate_limiting_pathshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_rate_limiting_paths_paths_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpoliciesrate_limiting_pathsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };
const policies_waf_request_matchheaderData = [
    {
    header: 'Method',
    key: 'method',
  },
{
    header: 'Path',
    key: 'path',
  },
{
    header: 'Version',
    key: 'version',
  },

];

const policies_waf_request_matchrowData = {policies_waf_request_match: []};

const policies_waf_request_matchhandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("policies_waf_request_match_method_id" + idPrefix).value = "";
    document.getElementById("policies_waf_request_match_path_id" + idPrefix).value = "";
    document.getElementById("policies_waf_request_match_phases_logging_id" + idPrefix).value = "";
    document.getElementById("policies_waf_request_match_phases_request_body_id" + idPrefix).value = "";
    document.getElementById("policies_waf_request_match_phases_request_headers_id" + idPrefix).value = "";
    document.getElementById("policies_waf_request_match_phases_response_body_id" + idPrefix).value = "";
    document.getElementById("policies_waf_request_match_phases_response_headers_id" + idPrefix).value = "";
    document.getElementById("policies_waf_request_match_version_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("policies_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addpolicieswaf_request_matchPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("policies_tab" + idPrefix).style.display = "none";

  };


const PoliciesPage = () => {

  const idPrefix = "";

  if(window.iagpage != "PoliciesPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "PoliciesPage";
  }

    const [policies_authorization, setpolicies_authorization] = React.useState([]);
    const [fetchedpolicies_authorization, setFetchedpolicies_authorization] = React.useState(false);

    React.useEffect(() => {
      policies_authorizationloadGrid();
    }, [fetchedpolicies_authorization]);

    const policies_authorizationloadGrid = React.useCallback(async (policies_authorization_action, policies_authorization_host, policies_authorization_name, policies_authorization_obligation_oidc_acr_values, policies_authorization_obligation_oidc_max_age, policies_authorization_obligation_oidc_prompt, policies_authorization_obligation_redirect_url, policies_authorization_rule, policies_authorization_paths,policies_authorization_methods,add) => {
      try {
        var attrs = [];
        if(policies_authorization_name) {
          if(add) {
            for(var i = 0; i < policies_authorizationrowData.policies_authorization.length; i++) {
              var tempId = ((policies_authorizationrowData.policies_authorization[i].name)?policies_authorizationrowData.policies_authorization[i].name:"") + "";
              if((window.policies_authorizationediting != true && window.policies_authorizationediting != "true") || tempId != window.policies_authorizationrowId) {
                attrs.push(policies_authorizationrowData.policies_authorization[i]);
              }
            }
            var newId = ((policies_authorization_name)?policies_authorization_name:"") + "";
            attrs.push({
              id: newId,
              action: policies_authorization_action,
host: policies_authorization_host,
methods: policies_authorization_methods,
name: policies_authorization_name,
    obligation: {
    oidc: {
acr_values: policies_authorization_obligation_oidc_acr_values,
max_age: policies_authorization_obligation_oidc_max_age,
prompt: policies_authorization_obligation_oidc_prompt,
    },
redirect_url: policies_authorization_obligation_redirect_url,
    },
paths: policies_authorization_paths,
rule: policies_authorization_rule,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_authorizationrowData.policies_authorization.length; i++) {
              if(policies_authorizationrowData.policies_authorization[i].name !== policies_authorization_name ) {
                attrs.push(policies_authorizationrowData.policies_authorization[i]);
              }
            }
          }
        } else {
          attrs = policies_authorizationrowData.policies_authorization;
        }
        policies_authorizationrowData.policies_authorization = attrs;
        const data = {policies_authorization: attrs};
        setpolicies_authorization(data.policies_authorization);

        if(policies_authorization_name !== undefined && policies_authorization_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_authorization_methods, setpolicies_authorization_methods] = React.useState([]);
    const [fetchedpolicies_authorization_methods, setFetchedpolicies_authorization_methods] = React.useState(false);

    React.useEffect(() => {
      policies_authorization_methodsloadGrid();
    }, [fetchedpolicies_authorization_methods]);

    const policies_authorization_methodsloadGrid = React.useCallback(async (policies_authorization_methods_methods, add) => {
      try {
        var attrs = [];
        if(policies_authorization_methods_methods) {
          if(add) {
            for(var i = 0; i < policies_authorization_methodsrowData.policies_authorization_methods.length; i++) {
              var tempId = ((policies_authorization_methodsrowData.policies_authorization_methods[i].methods)?policies_authorization_methodsrowData.policies_authorization_methods[i].methods:"") + "";
              if((window.policies_authorization_methodsediting != true && window.policies_authorization_methodsediting != "true") || tempId != window.policies_authorization_methodsrowId) {
                attrs.push(policies_authorization_methodsrowData.policies_authorization_methods[i]);
              }
            }
            var newId = ((policies_authorization_methods_methods)?policies_authorization_methods_methods:"") + "";
            attrs.push({
              id: newId,
              methods: policies_authorization_methods_methods,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_authorization_methodsrowData.policies_authorization_methods.length; i++) {
              if(policies_authorization_methodsrowData.policies_authorization_methods[i].methods !== policies_authorization_methods_methods ) {
                attrs.push(policies_authorization_methodsrowData.policies_authorization_methods[i]);
              }
            }
          }
        } else {
          attrs = policies_authorization_methodsrowData.policies_authorization_methods;
        }
        policies_authorization_methodsrowData.policies_authorization_methods = attrs;
        const data = {policies_authorization_methods: attrs};
        setpolicies_authorization_methods(data.policies_authorization_methods);

        if(policies_authorization_methods_methods !== undefined && policies_authorization_methods_methods !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_authorization_paths, setpolicies_authorization_paths] = React.useState([]);
    const [fetchedpolicies_authorization_paths, setFetchedpolicies_authorization_paths] = React.useState(false);

    React.useEffect(() => {
      policies_authorization_pathsloadGrid();
    }, [fetchedpolicies_authorization_paths]);

    const policies_authorization_pathsloadGrid = React.useCallback(async (policies_authorization_paths_paths, add) => {
      try {
        var attrs = [];
        if(policies_authorization_paths_paths) {
          if(add) {
            for(var i = 0; i < policies_authorization_pathsrowData.policies_authorization_paths.length; i++) {
              var tempId = ((policies_authorization_pathsrowData.policies_authorization_paths[i].paths)?policies_authorization_pathsrowData.policies_authorization_paths[i].paths:"") + "";
              if((window.policies_authorization_pathsediting != true && window.policies_authorization_pathsediting != "true") || tempId != window.policies_authorization_pathsrowId) {
                attrs.push(policies_authorization_pathsrowData.policies_authorization_paths[i]);
              }
            }
            var newId = ((policies_authorization_paths_paths)?policies_authorization_paths_paths:"") + "";
            attrs.push({
              id: newId,
              paths: policies_authorization_paths_paths,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_authorization_pathsrowData.policies_authorization_paths.length; i++) {
              if(policies_authorization_pathsrowData.policies_authorization_paths[i].paths !== policies_authorization_paths_paths ) {
                attrs.push(policies_authorization_pathsrowData.policies_authorization_paths[i]);
              }
            }
          }
        } else {
          attrs = policies_authorization_pathsrowData.policies_authorization_paths;
        }
        policies_authorization_pathsrowData.policies_authorization_paths = attrs;
        const data = {policies_authorization_paths: attrs};
        setpolicies_authorization_paths(data.policies_authorization_paths);

        if(policies_authorization_paths_paths !== undefined && policies_authorization_paths_paths !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_content_injection, setpolicies_content_injection] = React.useState([]);
    const [fetchedpolicies_content_injection, setFetchedpolicies_content_injection] = React.useState(false);

    React.useEffect(() => {
      policies_content_injectionloadGrid();
    }, [fetchedpolicies_content_injection]);

    const policies_content_injectionloadGrid = React.useCallback(async (policies_content_injection_content, policies_content_injection_full_line_match, policies_content_injection_location, policies_content_injection_name, policies_content_injection_replace_match, policies_content_injection_paths,add) => {
      try {
        var attrs = [];
        if(policies_content_injection_name) {
          if(add) {
            for(var i = 0; i < policies_content_injectionrowData.policies_content_injection.length; i++) {
              var tempId = ((policies_content_injectionrowData.policies_content_injection[i].name)?policies_content_injectionrowData.policies_content_injection[i].name:"") + "";
              if((window.policies_content_injectionediting != true && window.policies_content_injectionediting != "true") || tempId != window.policies_content_injectionrowId) {
                attrs.push(policies_content_injectionrowData.policies_content_injection[i]);
              }
            }
            var newId = ((policies_content_injection_name)?policies_content_injection_name:"") + "";
            attrs.push({
              id: newId,
              content: policies_content_injection_content,
full_line_match: policies_content_injection_full_line_match,
location: policies_content_injection_location,
name: policies_content_injection_name,
paths: policies_content_injection_paths,
replace_match: policies_content_injection_replace_match,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_content_injectionrowData.policies_content_injection.length; i++) {
              if(policies_content_injectionrowData.policies_content_injection[i].name !== policies_content_injection_name ) {
                attrs.push(policies_content_injectionrowData.policies_content_injection[i]);
              }
            }
          }
        } else {
          attrs = policies_content_injectionrowData.policies_content_injection;
        }
        policies_content_injectionrowData.policies_content_injection = attrs;
        const data = {policies_content_injection: attrs};
        setpolicies_content_injection(data.policies_content_injection);

        if(policies_content_injection_name !== undefined && policies_content_injection_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_content_injection_paths, setpolicies_content_injection_paths] = React.useState([]);
    const [fetchedpolicies_content_injection_paths, setFetchedpolicies_content_injection_paths] = React.useState(false);

    React.useEffect(() => {
      policies_content_injection_pathsloadGrid();
    }, [fetchedpolicies_content_injection_paths]);

    const policies_content_injection_pathsloadGrid = React.useCallback(async (policies_content_injection_paths_paths, add) => {
      try {
        var attrs = [];
        if(policies_content_injection_paths_paths) {
          if(add) {
            for(var i = 0; i < policies_content_injection_pathsrowData.policies_content_injection_paths.length; i++) {
              var tempId = ((policies_content_injection_pathsrowData.policies_content_injection_paths[i].paths)?policies_content_injection_pathsrowData.policies_content_injection_paths[i].paths:"") + "";
              if((window.policies_content_injection_pathsediting != true && window.policies_content_injection_pathsediting != "true") || tempId != window.policies_content_injection_pathsrowId) {
                attrs.push(policies_content_injection_pathsrowData.policies_content_injection_paths[i]);
              }
            }
            var newId = ((policies_content_injection_paths_paths)?policies_content_injection_paths_paths:"") + "";
            attrs.push({
              id: newId,
              paths: policies_content_injection_paths_paths,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_content_injection_pathsrowData.policies_content_injection_paths.length; i++) {
              if(policies_content_injection_pathsrowData.policies_content_injection_paths[i].paths !== policies_content_injection_paths_paths ) {
                attrs.push(policies_content_injection_pathsrowData.policies_content_injection_paths[i]);
              }
            }
          }
        } else {
          attrs = policies_content_injection_pathsrowData.policies_content_injection_paths;
        }
        policies_content_injection_pathsrowData.policies_content_injection_paths = attrs;
        const data = {policies_content_injection_paths: attrs};
        setpolicies_content_injection_paths(data.policies_content_injection_paths);

        if(policies_content_injection_paths_paths !== undefined && policies_content_injection_paths_paths !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_cors, setpolicies_cors] = React.useState([]);
    const [fetchedpolicies_cors, setFetchedpolicies_cors] = React.useState(false);

    React.useEffect(() => {
      policies_corsloadGrid();
    }, [fetchedpolicies_cors]);

    const policies_corsloadGrid = React.useCallback(async (policies_cors_host, policies_cors_method, policies_cors_name, policies_cors_policy_allow_credentials, policies_cors_policy_handle_pre_flight, policies_cors_policy_max_age, policies_cors_policy_expose_headers,policies_cors_policy_allow_origins,policies_cors_policy_allow_headers,policies_cors_paths,policies_cors_policy_allow_methods,add) => {
      try {
        var attrs = [];
        if(policies_cors_name) {
          if(add) {
            for(var i = 0; i < policies_corsrowData.policies_cors.length; i++) {
              var tempId = ((policies_corsrowData.policies_cors[i].name)?policies_corsrowData.policies_cors[i].name:"") + "";
              if((window.policies_corsediting != true && window.policies_corsediting != "true") || tempId != window.policies_corsrowId) {
                attrs.push(policies_corsrowData.policies_cors[i]);
              }
            }
            var newId = ((policies_cors_name)?policies_cors_name:"") + "";
            attrs.push({
              id: newId,
              host: policies_cors_host,
method: policies_cors_method,
name: policies_cors_name,
paths: policies_cors_paths,
    policy: {
allow_credentials: policies_cors_policy_allow_credentials,
allow_headers: policies_cors_policy_allow_headers,
allow_methods: policies_cors_policy_allow_methods,
allow_origins: policies_cors_policy_allow_origins,
expose_headers: policies_cors_policy_expose_headers,
handle_pre_flight: policies_cors_policy_handle_pre_flight,
max_age: policies_cors_policy_max_age,
    },
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_corsrowData.policies_cors.length; i++) {
              if(policies_corsrowData.policies_cors[i].name !== policies_cors_name ) {
                attrs.push(policies_corsrowData.policies_cors[i]);
              }
            }
          }
        } else {
          attrs = policies_corsrowData.policies_cors;
        }
        policies_corsrowData.policies_cors = attrs;
        const data = {policies_cors: attrs};
        setpolicies_cors(data.policies_cors);

        if(policies_cors_name !== undefined && policies_cors_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_cors_paths, setpolicies_cors_paths] = React.useState([]);
    const [fetchedpolicies_cors_paths, setFetchedpolicies_cors_paths] = React.useState(false);

    React.useEffect(() => {
      policies_cors_pathsloadGrid();
    }, [fetchedpolicies_cors_paths]);

    const policies_cors_pathsloadGrid = React.useCallback(async (policies_cors_paths_paths, add) => {
      try {
        var attrs = [];
        if(policies_cors_paths_paths) {
          if(add) {
            for(var i = 0; i < policies_cors_pathsrowData.policies_cors_paths.length; i++) {
              var tempId = ((policies_cors_pathsrowData.policies_cors_paths[i].paths)?policies_cors_pathsrowData.policies_cors_paths[i].paths:"") + "";
              if((window.policies_cors_pathsediting != true && window.policies_cors_pathsediting != "true") || tempId != window.policies_cors_pathsrowId) {
                attrs.push(policies_cors_pathsrowData.policies_cors_paths[i]);
              }
            }
            var newId = ((policies_cors_paths_paths)?policies_cors_paths_paths:"") + "";
            attrs.push({
              id: newId,
              paths: policies_cors_paths_paths,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_cors_pathsrowData.policies_cors_paths.length; i++) {
              if(policies_cors_pathsrowData.policies_cors_paths[i].paths !== policies_cors_paths_paths ) {
                attrs.push(policies_cors_pathsrowData.policies_cors_paths[i]);
              }
            }
          }
        } else {
          attrs = policies_cors_pathsrowData.policies_cors_paths;
        }
        policies_cors_pathsrowData.policies_cors_paths = attrs;
        const data = {policies_cors_paths: attrs};
        setpolicies_cors_paths(data.policies_cors_paths);

        if(policies_cors_paths_paths !== undefined && policies_cors_paths_paths !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_cors_policy_allow_headers, setpolicies_cors_policy_allow_headers] = React.useState([]);
    const [fetchedpolicies_cors_policy_allow_headers, setFetchedpolicies_cors_policy_allow_headers] = React.useState(false);

    React.useEffect(() => {
      policies_cors_policy_allow_headersloadGrid();
    }, [fetchedpolicies_cors_policy_allow_headers]);

    const policies_cors_policy_allow_headersloadGrid = React.useCallback(async (policies_cors_policy_allow_headers_allow_headers, add) => {
      try {
        var attrs = [];
        if(policies_cors_policy_allow_headers_allow_headers) {
          if(add) {
            for(var i = 0; i < policies_cors_policy_allow_headersrowData.policies_cors_policy_allow_headers.length; i++) {
              var tempId = ((policies_cors_policy_allow_headersrowData.policies_cors_policy_allow_headers[i].allow_headers)?policies_cors_policy_allow_headersrowData.policies_cors_policy_allow_headers[i].allow_headers:"") + "";
              if((window.policies_cors_policy_allow_headersediting != true && window.policies_cors_policy_allow_headersediting != "true") || tempId != window.policies_cors_policy_allow_headersrowId) {
                attrs.push(policies_cors_policy_allow_headersrowData.policies_cors_policy_allow_headers[i]);
              }
            }
            var newId = ((policies_cors_policy_allow_headers_allow_headers)?policies_cors_policy_allow_headers_allow_headers:"") + "";
            attrs.push({
              id: newId,
              allow_headers: policies_cors_policy_allow_headers_allow_headers,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_cors_policy_allow_headersrowData.policies_cors_policy_allow_headers.length; i++) {
              if(policies_cors_policy_allow_headersrowData.policies_cors_policy_allow_headers[i].allow_headers !== policies_cors_policy_allow_headers_allow_headers ) {
                attrs.push(policies_cors_policy_allow_headersrowData.policies_cors_policy_allow_headers[i]);
              }
            }
          }
        } else {
          attrs = policies_cors_policy_allow_headersrowData.policies_cors_policy_allow_headers;
        }
        policies_cors_policy_allow_headersrowData.policies_cors_policy_allow_headers = attrs;
        const data = {policies_cors_policy_allow_headers: attrs};
        setpolicies_cors_policy_allow_headers(data.policies_cors_policy_allow_headers);

        if(policies_cors_policy_allow_headers_allow_headers !== undefined && policies_cors_policy_allow_headers_allow_headers !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_cors_policy_allow_methods, setpolicies_cors_policy_allow_methods] = React.useState([]);
    const [fetchedpolicies_cors_policy_allow_methods, setFetchedpolicies_cors_policy_allow_methods] = React.useState(false);

    React.useEffect(() => {
      policies_cors_policy_allow_methodsloadGrid();
    }, [fetchedpolicies_cors_policy_allow_methods]);

    const policies_cors_policy_allow_methodsloadGrid = React.useCallback(async (policies_cors_policy_allow_methods_allow_methods, add) => {
      try {
        var attrs = [];
        if(policies_cors_policy_allow_methods_allow_methods) {
          if(add) {
            for(var i = 0; i < policies_cors_policy_allow_methodsrowData.policies_cors_policy_allow_methods.length; i++) {
              var tempId = ((policies_cors_policy_allow_methodsrowData.policies_cors_policy_allow_methods[i].allow_methods)?policies_cors_policy_allow_methodsrowData.policies_cors_policy_allow_methods[i].allow_methods:"") + "";
              if((window.policies_cors_policy_allow_methodsediting != true && window.policies_cors_policy_allow_methodsediting != "true") || tempId != window.policies_cors_policy_allow_methodsrowId) {
                attrs.push(policies_cors_policy_allow_methodsrowData.policies_cors_policy_allow_methods[i]);
              }
            }
            var newId = ((policies_cors_policy_allow_methods_allow_methods)?policies_cors_policy_allow_methods_allow_methods:"") + "";
            attrs.push({
              id: newId,
              allow_methods: policies_cors_policy_allow_methods_allow_methods,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_cors_policy_allow_methodsrowData.policies_cors_policy_allow_methods.length; i++) {
              if(policies_cors_policy_allow_methodsrowData.policies_cors_policy_allow_methods[i].allow_methods !== policies_cors_policy_allow_methods_allow_methods ) {
                attrs.push(policies_cors_policy_allow_methodsrowData.policies_cors_policy_allow_methods[i]);
              }
            }
          }
        } else {
          attrs = policies_cors_policy_allow_methodsrowData.policies_cors_policy_allow_methods;
        }
        policies_cors_policy_allow_methodsrowData.policies_cors_policy_allow_methods = attrs;
        const data = {policies_cors_policy_allow_methods: attrs};
        setpolicies_cors_policy_allow_methods(data.policies_cors_policy_allow_methods);

        if(policies_cors_policy_allow_methods_allow_methods !== undefined && policies_cors_policy_allow_methods_allow_methods !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_cors_policy_allow_origins, setpolicies_cors_policy_allow_origins] = React.useState([]);
    const [fetchedpolicies_cors_policy_allow_origins, setFetchedpolicies_cors_policy_allow_origins] = React.useState(false);

    React.useEffect(() => {
      policies_cors_policy_allow_originsloadGrid();
    }, [fetchedpolicies_cors_policy_allow_origins]);

    const policies_cors_policy_allow_originsloadGrid = React.useCallback(async (policies_cors_policy_allow_origins_allow_origins, add) => {
      try {
        var attrs = [];
        if(policies_cors_policy_allow_origins_allow_origins) {
          if(add) {
            for(var i = 0; i < policies_cors_policy_allow_originsrowData.policies_cors_policy_allow_origins.length; i++) {
              var tempId = ((policies_cors_policy_allow_originsrowData.policies_cors_policy_allow_origins[i].allow_origins)?policies_cors_policy_allow_originsrowData.policies_cors_policy_allow_origins[i].allow_origins:"") + "";
              if((window.policies_cors_policy_allow_originsediting != true && window.policies_cors_policy_allow_originsediting != "true") || tempId != window.policies_cors_policy_allow_originsrowId) {
                attrs.push(policies_cors_policy_allow_originsrowData.policies_cors_policy_allow_origins[i]);
              }
            }
            var newId = ((policies_cors_policy_allow_origins_allow_origins)?policies_cors_policy_allow_origins_allow_origins:"") + "";
            attrs.push({
              id: newId,
              allow_origins: policies_cors_policy_allow_origins_allow_origins,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_cors_policy_allow_originsrowData.policies_cors_policy_allow_origins.length; i++) {
              if(policies_cors_policy_allow_originsrowData.policies_cors_policy_allow_origins[i].allow_origins !== policies_cors_policy_allow_origins_allow_origins ) {
                attrs.push(policies_cors_policy_allow_originsrowData.policies_cors_policy_allow_origins[i]);
              }
            }
          }
        } else {
          attrs = policies_cors_policy_allow_originsrowData.policies_cors_policy_allow_origins;
        }
        policies_cors_policy_allow_originsrowData.policies_cors_policy_allow_origins = attrs;
        const data = {policies_cors_policy_allow_origins: attrs};
        setpolicies_cors_policy_allow_origins(data.policies_cors_policy_allow_origins);

        if(policies_cors_policy_allow_origins_allow_origins !== undefined && policies_cors_policy_allow_origins_allow_origins !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_cors_policy_expose_headers, setpolicies_cors_policy_expose_headers] = React.useState([]);
    const [fetchedpolicies_cors_policy_expose_headers, setFetchedpolicies_cors_policy_expose_headers] = React.useState(false);

    React.useEffect(() => {
      policies_cors_policy_expose_headersloadGrid();
    }, [fetchedpolicies_cors_policy_expose_headers]);

    const policies_cors_policy_expose_headersloadGrid = React.useCallback(async (policies_cors_policy_expose_headers_expose_headers, add) => {
      try {
        var attrs = [];
        if(policies_cors_policy_expose_headers_expose_headers) {
          if(add) {
            for(var i = 0; i < policies_cors_policy_expose_headersrowData.policies_cors_policy_expose_headers.length; i++) {
              var tempId = ((policies_cors_policy_expose_headersrowData.policies_cors_policy_expose_headers[i].expose_headers)?policies_cors_policy_expose_headersrowData.policies_cors_policy_expose_headers[i].expose_headers:"") + "";
              if((window.policies_cors_policy_expose_headersediting != true && window.policies_cors_policy_expose_headersediting != "true") || tempId != window.policies_cors_policy_expose_headersrowId) {
                attrs.push(policies_cors_policy_expose_headersrowData.policies_cors_policy_expose_headers[i]);
              }
            }
            var newId = ((policies_cors_policy_expose_headers_expose_headers)?policies_cors_policy_expose_headers_expose_headers:"") + "";
            attrs.push({
              id: newId,
              expose_headers: policies_cors_policy_expose_headers_expose_headers,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_cors_policy_expose_headersrowData.policies_cors_policy_expose_headers.length; i++) {
              if(policies_cors_policy_expose_headersrowData.policies_cors_policy_expose_headers[i].expose_headers !== policies_cors_policy_expose_headers_expose_headers ) {
                attrs.push(policies_cors_policy_expose_headersrowData.policies_cors_policy_expose_headers[i]);
              }
            }
          }
        } else {
          attrs = policies_cors_policy_expose_headersrowData.policies_cors_policy_expose_headers;
        }
        policies_cors_policy_expose_headersrowData.policies_cors_policy_expose_headers = attrs;
        const data = {policies_cors_policy_expose_headers: attrs};
        setpolicies_cors_policy_expose_headers(data.policies_cors_policy_expose_headers);

        if(policies_cors_policy_expose_headers_expose_headers !== undefined && policies_cors_policy_expose_headers_expose_headers !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_http_transformations_postauthn, setpolicies_http_transformations_postauthn] = React.useState([]);
    const [fetchedpolicies_http_transformations_postauthn, setFetchedpolicies_http_transformations_postauthn] = React.useState(false);

    React.useEffect(() => {
      policies_http_transformations_postauthnloadGrid();
    }, [fetchedpolicies_http_transformations_postauthn]);

    const policies_http_transformations_postauthnloadGrid = React.useCallback(async (policies_http_transformations_postauthn_host, policies_http_transformations_postauthn_name, policies_http_transformations_postauthn_rule, policies_http_transformations_postauthn_authentication_mechanisms,add) => {
      try {
        var attrs = [];
        if(policies_http_transformations_postauthn_name) {
          if(add) {
            for(var i = 0; i < policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn.length; i++) {
              var tempId = ((policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i].name)?policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i].name:"") + "";
              if((window.policies_http_transformations_postauthnediting != true && window.policies_http_transformations_postauthnediting != "true") || tempId != window.policies_http_transformations_postauthnrowId) {
                attrs.push(policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i]);
              }
            }
            var newId = ((policies_http_transformations_postauthn_name)?policies_http_transformations_postauthn_name:"") + "";
            attrs.push({
              id: newId,
              authentication_mechanisms: policies_http_transformations_postauthn_authentication_mechanisms,
host: policies_http_transformations_postauthn_host,
name: policies_http_transformations_postauthn_name,
rule: policies_http_transformations_postauthn_rule,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn.length; i++) {
              if(policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i].name !== policies_http_transformations_postauthn_name ) {
                attrs.push(policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i]);
              }
            }
          }
        } else {
          attrs = policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn;
        }
        policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn = attrs;
        const data = {policies_http_transformations_postauthn: attrs};
        setpolicies_http_transformations_postauthn(data.policies_http_transformations_postauthn);

        if(policies_http_transformations_postauthn_name !== undefined && policies_http_transformations_postauthn_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_http_transformations_postauthn_authentication_mechanisms, setpolicies_http_transformations_postauthn_authentication_mechanisms] = React.useState([]);
    const [fetchedpolicies_http_transformations_postauthn_authentication_mechanisms, setFetchedpolicies_http_transformations_postauthn_authentication_mechanisms] = React.useState(false);

    React.useEffect(() => {
      policies_http_transformations_postauthn_authentication_mechanismsloadGrid();
    }, [fetchedpolicies_http_transformations_postauthn_authentication_mechanisms]);

    const policies_http_transformations_postauthn_authentication_mechanismsloadGrid = React.useCallback(async (policies_http_transformations_postauthn_authentication_mechanisms_authentication_mechanisms, add) => {
      try {
        var attrs = [];
        if(policies_http_transformations_postauthn_authentication_mechanisms_authentication_mechanisms) {
          if(add) {
            for(var i = 0; i < policies_http_transformations_postauthn_authentication_mechanismsrowData.policies_http_transformations_postauthn_authentication_mechanisms.length; i++) {
              var tempId = ((policies_http_transformations_postauthn_authentication_mechanismsrowData.policies_http_transformations_postauthn_authentication_mechanisms[i].authentication_mechanisms)?policies_http_transformations_postauthn_authentication_mechanismsrowData.policies_http_transformations_postauthn_authentication_mechanisms[i].authentication_mechanisms:"") + "";
              if((window.policies_http_transformations_postauthn_authentication_mechanismsediting != true && window.policies_http_transformations_postauthn_authentication_mechanismsediting != "true") || tempId != window.policies_http_transformations_postauthn_authentication_mechanismsrowId) {
                attrs.push(policies_http_transformations_postauthn_authentication_mechanismsrowData.policies_http_transformations_postauthn_authentication_mechanisms[i]);
              }
            }
            var newId = ((policies_http_transformations_postauthn_authentication_mechanisms_authentication_mechanisms)?policies_http_transformations_postauthn_authentication_mechanisms_authentication_mechanisms:"") + "";
            attrs.push({
              id: newId,
              authentication_mechanisms: policies_http_transformations_postauthn_authentication_mechanisms_authentication_mechanisms,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_http_transformations_postauthn_authentication_mechanismsrowData.policies_http_transformations_postauthn_authentication_mechanisms.length; i++) {
              if(policies_http_transformations_postauthn_authentication_mechanismsrowData.policies_http_transformations_postauthn_authentication_mechanisms[i].authentication_mechanisms !== policies_http_transformations_postauthn_authentication_mechanisms_authentication_mechanisms ) {
                attrs.push(policies_http_transformations_postauthn_authentication_mechanismsrowData.policies_http_transformations_postauthn_authentication_mechanisms[i]);
              }
            }
          }
        } else {
          attrs = policies_http_transformations_postauthn_authentication_mechanismsrowData.policies_http_transformations_postauthn_authentication_mechanisms;
        }
        policies_http_transformations_postauthn_authentication_mechanismsrowData.policies_http_transformations_postauthn_authentication_mechanisms = attrs;
        const data = {policies_http_transformations_postauthn_authentication_mechanisms: attrs};
        setpolicies_http_transformations_postauthn_authentication_mechanisms(data.policies_http_transformations_postauthn_authentication_mechanisms);

        if(policies_http_transformations_postauthn_authentication_mechanisms_authentication_mechanisms !== undefined && policies_http_transformations_postauthn_authentication_mechanisms_authentication_mechanisms !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_http_transformations_postazn, setpolicies_http_transformations_postazn] = React.useState([]);
    const [fetchedpolicies_http_transformations_postazn, setFetchedpolicies_http_transformations_postazn] = React.useState(false);

    React.useEffect(() => {
      policies_http_transformations_postaznloadGrid();
    }, [fetchedpolicies_http_transformations_postazn]);

    const policies_http_transformations_postaznloadGrid = React.useCallback(async (policies_http_transformations_postazn_host, policies_http_transformations_postazn_method, policies_http_transformations_postazn_name, policies_http_transformations_postazn_rule, policies_http_transformations_postazn_paths,add) => {
      try {
        var attrs = [];
        if(policies_http_transformations_postazn_name) {
          if(add) {
            for(var i = 0; i < policies_http_transformations_postaznrowData.policies_http_transformations_postazn.length; i++) {
              var tempId = ((policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i].name)?policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i].name:"") + "";
              if((window.policies_http_transformations_postaznediting != true && window.policies_http_transformations_postaznediting != "true") || tempId != window.policies_http_transformations_postaznrowId) {
                attrs.push(policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i]);
              }
            }
            var newId = ((policies_http_transformations_postazn_name)?policies_http_transformations_postazn_name:"") + "";
            attrs.push({
              id: newId,
              host: policies_http_transformations_postazn_host,
method: policies_http_transformations_postazn_method,
name: policies_http_transformations_postazn_name,
paths: policies_http_transformations_postazn_paths,
rule: policies_http_transformations_postazn_rule,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_http_transformations_postaznrowData.policies_http_transformations_postazn.length; i++) {
              if(policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i].name !== policies_http_transformations_postazn_name ) {
                attrs.push(policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i]);
              }
            }
          }
        } else {
          attrs = policies_http_transformations_postaznrowData.policies_http_transformations_postazn;
        }
        policies_http_transformations_postaznrowData.policies_http_transformations_postazn = attrs;
        const data = {policies_http_transformations_postazn: attrs};
        setpolicies_http_transformations_postazn(data.policies_http_transformations_postazn);

        if(policies_http_transformations_postazn_name !== undefined && policies_http_transformations_postazn_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_http_transformations_postazn_paths, setpolicies_http_transformations_postazn_paths] = React.useState([]);
    const [fetchedpolicies_http_transformations_postazn_paths, setFetchedpolicies_http_transformations_postazn_paths] = React.useState(false);

    React.useEffect(() => {
      policies_http_transformations_postazn_pathsloadGrid();
    }, [fetchedpolicies_http_transformations_postazn_paths]);

    const policies_http_transformations_postazn_pathsloadGrid = React.useCallback(async (policies_http_transformations_postazn_paths_paths, add) => {
      try {
        var attrs = [];
        if(policies_http_transformations_postazn_paths_paths) {
          if(add) {
            for(var i = 0; i < policies_http_transformations_postazn_pathsrowData.policies_http_transformations_postazn_paths.length; i++) {
              var tempId = ((policies_http_transformations_postazn_pathsrowData.policies_http_transformations_postazn_paths[i].paths)?policies_http_transformations_postazn_pathsrowData.policies_http_transformations_postazn_paths[i].paths:"") + "";
              if((window.policies_http_transformations_postazn_pathsediting != true && window.policies_http_transformations_postazn_pathsediting != "true") || tempId != window.policies_http_transformations_postazn_pathsrowId) {
                attrs.push(policies_http_transformations_postazn_pathsrowData.policies_http_transformations_postazn_paths[i]);
              }
            }
            var newId = ((policies_http_transformations_postazn_paths_paths)?policies_http_transformations_postazn_paths_paths:"") + "";
            attrs.push({
              id: newId,
              paths: policies_http_transformations_postazn_paths_paths,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_http_transformations_postazn_pathsrowData.policies_http_transformations_postazn_paths.length; i++) {
              if(policies_http_transformations_postazn_pathsrowData.policies_http_transformations_postazn_paths[i].paths !== policies_http_transformations_postazn_paths_paths ) {
                attrs.push(policies_http_transformations_postazn_pathsrowData.policies_http_transformations_postazn_paths[i]);
              }
            }
          }
        } else {
          attrs = policies_http_transformations_postazn_pathsrowData.policies_http_transformations_postazn_paths;
        }
        policies_http_transformations_postazn_pathsrowData.policies_http_transformations_postazn_paths = attrs;
        const data = {policies_http_transformations_postazn_paths: attrs};
        setpolicies_http_transformations_postazn_paths(data.policies_http_transformations_postazn_paths);

        if(policies_http_transformations_postazn_paths_paths !== undefined && policies_http_transformations_postazn_paths_paths !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_http_transformations_preazn, setpolicies_http_transformations_preazn] = React.useState([]);
    const [fetchedpolicies_http_transformations_preazn, setFetchedpolicies_http_transformations_preazn] = React.useState(false);

    React.useEffect(() => {
      policies_http_transformations_preaznloadGrid();
    }, [fetchedpolicies_http_transformations_preazn]);

    const policies_http_transformations_preaznloadGrid = React.useCallback(async (policies_http_transformations_preazn_host, policies_http_transformations_preazn_method, policies_http_transformations_preazn_name, policies_http_transformations_preazn_rule, policies_http_transformations_preazn_paths,add) => {
      try {
        var attrs = [];
        if(policies_http_transformations_preazn_name) {
          if(add) {
            for(var i = 0; i < policies_http_transformations_preaznrowData.policies_http_transformations_preazn.length; i++) {
              var tempId = ((policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i].name)?policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i].name:"") + "";
              if((window.policies_http_transformations_preaznediting != true && window.policies_http_transformations_preaznediting != "true") || tempId != window.policies_http_transformations_preaznrowId) {
                attrs.push(policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i]);
              }
            }
            var newId = ((policies_http_transformations_preazn_name)?policies_http_transformations_preazn_name:"") + "";
            attrs.push({
              id: newId,
              host: policies_http_transformations_preazn_host,
method: policies_http_transformations_preazn_method,
name: policies_http_transformations_preazn_name,
paths: policies_http_transformations_preazn_paths,
rule: policies_http_transformations_preazn_rule,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_http_transformations_preaznrowData.policies_http_transformations_preazn.length; i++) {
              if(policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i].name !== policies_http_transformations_preazn_name ) {
                attrs.push(policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i]);
              }
            }
          }
        } else {
          attrs = policies_http_transformations_preaznrowData.policies_http_transformations_preazn;
        }
        policies_http_transformations_preaznrowData.policies_http_transformations_preazn = attrs;
        const data = {policies_http_transformations_preazn: attrs};
        setpolicies_http_transformations_preazn(data.policies_http_transformations_preazn);

        if(policies_http_transformations_preazn_name !== undefined && policies_http_transformations_preazn_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_http_transformations_preazn_paths, setpolicies_http_transformations_preazn_paths] = React.useState([]);
    const [fetchedpolicies_http_transformations_preazn_paths, setFetchedpolicies_http_transformations_preazn_paths] = React.useState(false);

    React.useEffect(() => {
      policies_http_transformations_preazn_pathsloadGrid();
    }, [fetchedpolicies_http_transformations_preazn_paths]);

    const policies_http_transformations_preazn_pathsloadGrid = React.useCallback(async (policies_http_transformations_preazn_paths_paths, add) => {
      try {
        var attrs = [];
        if(policies_http_transformations_preazn_paths_paths) {
          if(add) {
            for(var i = 0; i < policies_http_transformations_preazn_pathsrowData.policies_http_transformations_preazn_paths.length; i++) {
              var tempId = ((policies_http_transformations_preazn_pathsrowData.policies_http_transformations_preazn_paths[i].paths)?policies_http_transformations_preazn_pathsrowData.policies_http_transformations_preazn_paths[i].paths:"") + "";
              if((window.policies_http_transformations_preazn_pathsediting != true && window.policies_http_transformations_preazn_pathsediting != "true") || tempId != window.policies_http_transformations_preazn_pathsrowId) {
                attrs.push(policies_http_transformations_preazn_pathsrowData.policies_http_transformations_preazn_paths[i]);
              }
            }
            var newId = ((policies_http_transformations_preazn_paths_paths)?policies_http_transformations_preazn_paths_paths:"") + "";
            attrs.push({
              id: newId,
              paths: policies_http_transformations_preazn_paths_paths,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_http_transformations_preazn_pathsrowData.policies_http_transformations_preazn_paths.length; i++) {
              if(policies_http_transformations_preazn_pathsrowData.policies_http_transformations_preazn_paths[i].paths !== policies_http_transformations_preazn_paths_paths ) {
                attrs.push(policies_http_transformations_preazn_pathsrowData.policies_http_transformations_preazn_paths[i]);
              }
            }
          }
        } else {
          attrs = policies_http_transformations_preazn_pathsrowData.policies_http_transformations_preazn_paths;
        }
        policies_http_transformations_preazn_pathsrowData.policies_http_transformations_preazn_paths = attrs;
        const data = {policies_http_transformations_preazn_paths: attrs};
        setpolicies_http_transformations_preazn_paths(data.policies_http_transformations_preazn_paths);

        if(policies_http_transformations_preazn_paths_paths !== undefined && policies_http_transformations_preazn_paths_paths !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_http_transformations_request, setpolicies_http_transformations_request] = React.useState([]);
    const [fetchedpolicies_http_transformations_request, setFetchedpolicies_http_transformations_request] = React.useState(false);

    React.useEffect(() => {
      policies_http_transformations_requestloadGrid();
    }, [fetchedpolicies_http_transformations_request]);

    const policies_http_transformations_requestloadGrid = React.useCallback(async (policies_http_transformations_request_host, policies_http_transformations_request_method, policies_http_transformations_request_name, policies_http_transformations_request_rule, policies_http_transformations_request_paths,add) => {
      try {
        var attrs = [];
        if(policies_http_transformations_request_name) {
          if(add) {
            for(var i = 0; i < policies_http_transformations_requestrowData.policies_http_transformations_request.length; i++) {
              var tempId = ((policies_http_transformations_requestrowData.policies_http_transformations_request[i].name)?policies_http_transformations_requestrowData.policies_http_transformations_request[i].name:"") + "";
              if((window.policies_http_transformations_requestediting != true && window.policies_http_transformations_requestediting != "true") || tempId != window.policies_http_transformations_requestrowId) {
                attrs.push(policies_http_transformations_requestrowData.policies_http_transformations_request[i]);
              }
            }
            var newId = ((policies_http_transformations_request_name)?policies_http_transformations_request_name:"") + "";
            attrs.push({
              id: newId,
              host: policies_http_transformations_request_host,
method: policies_http_transformations_request_method,
name: policies_http_transformations_request_name,
paths: policies_http_transformations_request_paths,
rule: policies_http_transformations_request_rule,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_http_transformations_requestrowData.policies_http_transformations_request.length; i++) {
              if(policies_http_transformations_requestrowData.policies_http_transformations_request[i].name !== policies_http_transformations_request_name ) {
                attrs.push(policies_http_transformations_requestrowData.policies_http_transformations_request[i]);
              }
            }
          }
        } else {
          attrs = policies_http_transformations_requestrowData.policies_http_transformations_request;
        }
        policies_http_transformations_requestrowData.policies_http_transformations_request = attrs;
        const data = {policies_http_transformations_request: attrs};
        setpolicies_http_transformations_request(data.policies_http_transformations_request);

        if(policies_http_transformations_request_name !== undefined && policies_http_transformations_request_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_http_transformations_request_paths, setpolicies_http_transformations_request_paths] = React.useState([]);
    const [fetchedpolicies_http_transformations_request_paths, setFetchedpolicies_http_transformations_request_paths] = React.useState(false);

    React.useEffect(() => {
      policies_http_transformations_request_pathsloadGrid();
    }, [fetchedpolicies_http_transformations_request_paths]);

    const policies_http_transformations_request_pathsloadGrid = React.useCallback(async (policies_http_transformations_request_paths_paths, add) => {
      try {
        var attrs = [];
        if(policies_http_transformations_request_paths_paths) {
          if(add) {
            for(var i = 0; i < policies_http_transformations_request_pathsrowData.policies_http_transformations_request_paths.length; i++) {
              var tempId = ((policies_http_transformations_request_pathsrowData.policies_http_transformations_request_paths[i].paths)?policies_http_transformations_request_pathsrowData.policies_http_transformations_request_paths[i].paths:"") + "";
              if((window.policies_http_transformations_request_pathsediting != true && window.policies_http_transformations_request_pathsediting != "true") || tempId != window.policies_http_transformations_request_pathsrowId) {
                attrs.push(policies_http_transformations_request_pathsrowData.policies_http_transformations_request_paths[i]);
              }
            }
            var newId = ((policies_http_transformations_request_paths_paths)?policies_http_transformations_request_paths_paths:"") + "";
            attrs.push({
              id: newId,
              paths: policies_http_transformations_request_paths_paths,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_http_transformations_request_pathsrowData.policies_http_transformations_request_paths.length; i++) {
              if(policies_http_transformations_request_pathsrowData.policies_http_transformations_request_paths[i].paths !== policies_http_transformations_request_paths_paths ) {
                attrs.push(policies_http_transformations_request_pathsrowData.policies_http_transformations_request_paths[i]);
              }
            }
          }
        } else {
          attrs = policies_http_transformations_request_pathsrowData.policies_http_transformations_request_paths;
        }
        policies_http_transformations_request_pathsrowData.policies_http_transformations_request_paths = attrs;
        const data = {policies_http_transformations_request_paths: attrs};
        setpolicies_http_transformations_request_paths(data.policies_http_transformations_request_paths);

        if(policies_http_transformations_request_paths_paths !== undefined && policies_http_transformations_request_paths_paths !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_http_transformations_response, setpolicies_http_transformations_response] = React.useState([]);
    const [fetchedpolicies_http_transformations_response, setFetchedpolicies_http_transformations_response] = React.useState(false);

    React.useEffect(() => {
      policies_http_transformations_responseloadGrid();
    }, [fetchedpolicies_http_transformations_response]);

    const policies_http_transformations_responseloadGrid = React.useCallback(async (policies_http_transformations_response_host, policies_http_transformations_response_method, policies_http_transformations_response_name, policies_http_transformations_response_rule, policies_http_transformations_response_paths,add) => {
      try {
        var attrs = [];
        if(policies_http_transformations_response_name) {
          if(add) {
            for(var i = 0; i < policies_http_transformations_responserowData.policies_http_transformations_response.length; i++) {
              var tempId = ((policies_http_transformations_responserowData.policies_http_transformations_response[i].name)?policies_http_transformations_responserowData.policies_http_transformations_response[i].name:"") + "";
              if((window.policies_http_transformations_responseediting != true && window.policies_http_transformations_responseediting != "true") || tempId != window.policies_http_transformations_responserowId) {
                attrs.push(policies_http_transformations_responserowData.policies_http_transformations_response[i]);
              }
            }
            var newId = ((policies_http_transformations_response_name)?policies_http_transformations_response_name:"") + "";
            attrs.push({
              id: newId,
              host: policies_http_transformations_response_host,
method: policies_http_transformations_response_method,
name: policies_http_transformations_response_name,
paths: policies_http_transformations_response_paths,
rule: policies_http_transformations_response_rule,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_http_transformations_responserowData.policies_http_transformations_response.length; i++) {
              if(policies_http_transformations_responserowData.policies_http_transformations_response[i].name !== policies_http_transformations_response_name ) {
                attrs.push(policies_http_transformations_responserowData.policies_http_transformations_response[i]);
              }
            }
          }
        } else {
          attrs = policies_http_transformations_responserowData.policies_http_transformations_response;
        }
        policies_http_transformations_responserowData.policies_http_transformations_response = attrs;
        const data = {policies_http_transformations_response: attrs};
        setpolicies_http_transformations_response(data.policies_http_transformations_response);

        if(policies_http_transformations_response_name !== undefined && policies_http_transformations_response_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_http_transformations_response_paths, setpolicies_http_transformations_response_paths] = React.useState([]);
    const [fetchedpolicies_http_transformations_response_paths, setFetchedpolicies_http_transformations_response_paths] = React.useState(false);

    React.useEffect(() => {
      policies_http_transformations_response_pathsloadGrid();
    }, [fetchedpolicies_http_transformations_response_paths]);

    const policies_http_transformations_response_pathsloadGrid = React.useCallback(async (policies_http_transformations_response_paths_paths, add) => {
      try {
        var attrs = [];
        if(policies_http_transformations_response_paths_paths) {
          if(add) {
            for(var i = 0; i < policies_http_transformations_response_pathsrowData.policies_http_transformations_response_paths.length; i++) {
              var tempId = ((policies_http_transformations_response_pathsrowData.policies_http_transformations_response_paths[i].paths)?policies_http_transformations_response_pathsrowData.policies_http_transformations_response_paths[i].paths:"") + "";
              if((window.policies_http_transformations_response_pathsediting != true && window.policies_http_transformations_response_pathsediting != "true") || tempId != window.policies_http_transformations_response_pathsrowId) {
                attrs.push(policies_http_transformations_response_pathsrowData.policies_http_transformations_response_paths[i]);
              }
            }
            var newId = ((policies_http_transformations_response_paths_paths)?policies_http_transformations_response_paths_paths:"") + "";
            attrs.push({
              id: newId,
              paths: policies_http_transformations_response_paths_paths,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_http_transformations_response_pathsrowData.policies_http_transformations_response_paths.length; i++) {
              if(policies_http_transformations_response_pathsrowData.policies_http_transformations_response_paths[i].paths !== policies_http_transformations_response_paths_paths ) {
                attrs.push(policies_http_transformations_response_pathsrowData.policies_http_transformations_response_paths[i]);
              }
            }
          }
        } else {
          attrs = policies_http_transformations_response_pathsrowData.policies_http_transformations_response_paths;
        }
        policies_http_transformations_response_pathsrowData.policies_http_transformations_response_paths = attrs;
        const data = {policies_http_transformations_response_paths: attrs};
        setpolicies_http_transformations_response_paths(data.policies_http_transformations_response_paths);

        if(policies_http_transformations_response_paths_paths !== undefined && policies_http_transformations_response_paths_paths !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_http_transformations_secrets, setpolicies_http_transformations_secrets] = React.useState([]);
    const [fetchedpolicies_http_transformations_secrets, setFetchedpolicies_http_transformations_secrets] = React.useState(false);

    React.useEffect(() => {
      policies_http_transformations_secretsloadGrid();
    }, [fetchedpolicies_http_transformations_secrets]);

    const policies_http_transformations_secretsloadGrid = React.useCallback(async (policies_http_transformations_secrets_name, policies_http_transformations_secrets_value, add) => {
      try {
        var attrs = [];
        if(policies_http_transformations_secrets_name) {
          if(add) {
            for(var i = 0; i < policies_http_transformations_secretsrowData.policies_http_transformations_secrets.length; i++) {
              var tempId = ((policies_http_transformations_secretsrowData.policies_http_transformations_secrets[i].name)?policies_http_transformations_secretsrowData.policies_http_transformations_secrets[i].name:"") + "";
              if((window.policies_http_transformations_secretsediting != true && window.policies_http_transformations_secretsediting != "true") || tempId != window.policies_http_transformations_secretsrowId) {
                attrs.push(policies_http_transformations_secretsrowData.policies_http_transformations_secrets[i]);
              }
            }
            var newId = ((policies_http_transformations_secrets_name)?policies_http_transformations_secrets_name:"") + "";
            attrs.push({
              id: newId,
              name: policies_http_transformations_secrets_name,
value: policies_http_transformations_secrets_value,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_http_transformations_secretsrowData.policies_http_transformations_secrets.length; i++) {
              if(policies_http_transformations_secretsrowData.policies_http_transformations_secrets[i].name !== policies_http_transformations_secrets_name ) {
                attrs.push(policies_http_transformations_secretsrowData.policies_http_transformations_secrets[i]);
              }
            }
          }
        } else {
          attrs = policies_http_transformations_secretsrowData.policies_http_transformations_secrets;
        }
        policies_http_transformations_secretsrowData.policies_http_transformations_secrets = attrs;
        const data = {policies_http_transformations_secrets: attrs};
        setpolicies_http_transformations_secrets(data.policies_http_transformations_secrets);

        if(policies_http_transformations_secrets_name !== undefined && policies_http_transformations_secrets_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_rate_limiting, setpolicies_rate_limiting] = React.useState([]);
    const [fetchedpolicies_rate_limiting, setFetchedpolicies_rate_limiting] = React.useState(false);

    React.useEffect(() => {
      policies_rate_limitingloadGrid();
    }, [fetchedpolicies_rate_limiting]);

    const policies_rate_limitingloadGrid = React.useCallback(async (policies_rate_limiting_name, policies_rate_limiting_rule, policies_rate_limiting_methods,policies_rate_limiting_paths,add) => {
      try {
        var attrs = [];
        if(policies_rate_limiting_name) {
          if(add) {
            for(var i = 0; i < policies_rate_limitingrowData.policies_rate_limiting.length; i++) {
              var tempId = ((policies_rate_limitingrowData.policies_rate_limiting[i].name)?policies_rate_limitingrowData.policies_rate_limiting[i].name:"") + "";
              if((window.policies_rate_limitingediting != true && window.policies_rate_limitingediting != "true") || tempId != window.policies_rate_limitingrowId) {
                attrs.push(policies_rate_limitingrowData.policies_rate_limiting[i]);
              }
            }
            var newId = ((policies_rate_limiting_name)?policies_rate_limiting_name:"") + "";
            attrs.push({
              id: newId,
              methods: policies_rate_limiting_methods,
name: policies_rate_limiting_name,
paths: policies_rate_limiting_paths,
rule: policies_rate_limiting_rule,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_rate_limitingrowData.policies_rate_limiting.length; i++) {
              if(policies_rate_limitingrowData.policies_rate_limiting[i].name !== policies_rate_limiting_name ) {
                attrs.push(policies_rate_limitingrowData.policies_rate_limiting[i]);
              }
            }
          }
        } else {
          attrs = policies_rate_limitingrowData.policies_rate_limiting;
        }
        policies_rate_limitingrowData.policies_rate_limiting = attrs;
        const data = {policies_rate_limiting: attrs};
        setpolicies_rate_limiting(data.policies_rate_limiting);

        if(policies_rate_limiting_name !== undefined && policies_rate_limiting_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_rate_limiting_methods, setpolicies_rate_limiting_methods] = React.useState([]);
    const [fetchedpolicies_rate_limiting_methods, setFetchedpolicies_rate_limiting_methods] = React.useState(false);

    React.useEffect(() => {
      policies_rate_limiting_methodsloadGrid();
    }, [fetchedpolicies_rate_limiting_methods]);

    const policies_rate_limiting_methodsloadGrid = React.useCallback(async (policies_rate_limiting_methods_methods, add) => {
      try {
        var attrs = [];
        if(policies_rate_limiting_methods_methods) {
          if(add) {
            for(var i = 0; i < policies_rate_limiting_methodsrowData.policies_rate_limiting_methods.length; i++) {
              var tempId = ((policies_rate_limiting_methodsrowData.policies_rate_limiting_methods[i].methods)?policies_rate_limiting_methodsrowData.policies_rate_limiting_methods[i].methods:"") + "";
              if((window.policies_rate_limiting_methodsediting != true && window.policies_rate_limiting_methodsediting != "true") || tempId != window.policies_rate_limiting_methodsrowId) {
                attrs.push(policies_rate_limiting_methodsrowData.policies_rate_limiting_methods[i]);
              }
            }
            var newId = ((policies_rate_limiting_methods_methods)?policies_rate_limiting_methods_methods:"") + "";
            attrs.push({
              id: newId,
              methods: policies_rate_limiting_methods_methods,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_rate_limiting_methodsrowData.policies_rate_limiting_methods.length; i++) {
              if(policies_rate_limiting_methodsrowData.policies_rate_limiting_methods[i].methods !== policies_rate_limiting_methods_methods ) {
                attrs.push(policies_rate_limiting_methodsrowData.policies_rate_limiting_methods[i]);
              }
            }
          }
        } else {
          attrs = policies_rate_limiting_methodsrowData.policies_rate_limiting_methods;
        }
        policies_rate_limiting_methodsrowData.policies_rate_limiting_methods = attrs;
        const data = {policies_rate_limiting_methods: attrs};
        setpolicies_rate_limiting_methods(data.policies_rate_limiting_methods);

        if(policies_rate_limiting_methods_methods !== undefined && policies_rate_limiting_methods_methods !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_rate_limiting_paths, setpolicies_rate_limiting_paths] = React.useState([]);
    const [fetchedpolicies_rate_limiting_paths, setFetchedpolicies_rate_limiting_paths] = React.useState(false);

    React.useEffect(() => {
      policies_rate_limiting_pathsloadGrid();
    }, [fetchedpolicies_rate_limiting_paths]);

    const policies_rate_limiting_pathsloadGrid = React.useCallback(async (policies_rate_limiting_paths_paths, add) => {
      try {
        var attrs = [];
        if(policies_rate_limiting_paths_paths) {
          if(add) {
            for(var i = 0; i < policies_rate_limiting_pathsrowData.policies_rate_limiting_paths.length; i++) {
              var tempId = ((policies_rate_limiting_pathsrowData.policies_rate_limiting_paths[i].paths)?policies_rate_limiting_pathsrowData.policies_rate_limiting_paths[i].paths:"") + "";
              if((window.policies_rate_limiting_pathsediting != true && window.policies_rate_limiting_pathsediting != "true") || tempId != window.policies_rate_limiting_pathsrowId) {
                attrs.push(policies_rate_limiting_pathsrowData.policies_rate_limiting_paths[i]);
              }
            }
            var newId = ((policies_rate_limiting_paths_paths)?policies_rate_limiting_paths_paths:"") + "";
            attrs.push({
              id: newId,
              paths: policies_rate_limiting_paths_paths,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_rate_limiting_pathsrowData.policies_rate_limiting_paths.length; i++) {
              if(policies_rate_limiting_pathsrowData.policies_rate_limiting_paths[i].paths !== policies_rate_limiting_paths_paths ) {
                attrs.push(policies_rate_limiting_pathsrowData.policies_rate_limiting_paths[i]);
              }
            }
          }
        } else {
          attrs = policies_rate_limiting_pathsrowData.policies_rate_limiting_paths;
        }
        policies_rate_limiting_pathsrowData.policies_rate_limiting_paths = attrs;
        const data = {policies_rate_limiting_paths: attrs};
        setpolicies_rate_limiting_paths(data.policies_rate_limiting_paths);

        if(policies_rate_limiting_paths_paths !== undefined && policies_rate_limiting_paths_paths !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [policies_waf_request_match, setpolicies_waf_request_match] = React.useState([]);
    const [fetchedpolicies_waf_request_match, setFetchedpolicies_waf_request_match] = React.useState(false);

    React.useEffect(() => {
      policies_waf_request_matchloadGrid();
    }, [fetchedpolicies_waf_request_match]);

    const policies_waf_request_matchloadGrid = React.useCallback(async (policies_waf_request_match_method, policies_waf_request_match_path, policies_waf_request_match_phases_logging, policies_waf_request_match_phases_request_body, policies_waf_request_match_phases_request_headers, policies_waf_request_match_phases_response_body, policies_waf_request_match_phases_response_headers, policies_waf_request_match_version, add) => {
      try {
        var attrs = [];
        if(policies_waf_request_match_method || policies_waf_request_match_version || policies_waf_request_match_path) {
          if(add) {
            for(var i = 0; i < policies_waf_request_matchrowData.policies_waf_request_match.length; i++) {
              var tempId = ((policies_waf_request_matchrowData.policies_waf_request_match[i].method)?policies_waf_request_matchrowData.policies_waf_request_match[i].method:"") + ((policies_waf_request_matchrowData.policies_waf_request_match[i].version)?policies_waf_request_matchrowData.policies_waf_request_match[i].version:"") + ((policies_waf_request_matchrowData.policies_waf_request_match[i].path)?policies_waf_request_matchrowData.policies_waf_request_match[i].path:"") + "";
              if((window.policies_waf_request_matchediting != true && window.policies_waf_request_matchediting != "true") || tempId != window.policies_waf_request_matchrowId) {
                attrs.push(policies_waf_request_matchrowData.policies_waf_request_match[i]);
              }
            }
            var newId = ((policies_waf_request_match_method)?policies_waf_request_match_method:"") + ((policies_waf_request_match_version)?policies_waf_request_match_version:"") + ((policies_waf_request_match_path)?policies_waf_request_match_path:"") + "";
            attrs.push({
              id: newId,
              method: policies_waf_request_match_method,
path: policies_waf_request_match_path,
    phases: {
logging: policies_waf_request_match_phases_logging,
request_body: policies_waf_request_match_phases_request_body,
request_headers: policies_waf_request_match_phases_request_headers,
response_body: policies_waf_request_match_phases_response_body,
response_headers: policies_waf_request_match_phases_response_headers,
    },
version: policies_waf_request_match_version,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < policies_waf_request_matchrowData.policies_waf_request_match.length; i++) {
              if(policies_waf_request_matchrowData.policies_waf_request_match[i].method !== policies_waf_request_match_method  && policies_waf_request_matchrowData.policies_waf_request_match[i].version !== policies_waf_request_match_version  && policies_waf_request_matchrowData.policies_waf_request_match[i].path !== policies_waf_request_match_path ) {
                attrs.push(policies_waf_request_matchrowData.policies_waf_request_match[i]);
              }
            }
          }
        } else {
          attrs = policies_waf_request_matchrowData.policies_waf_request_match;
        }
        policies_waf_request_matchrowData.policies_waf_request_match = attrs;
        const data = {policies_waf_request_match: attrs};
        setpolicies_waf_request_match(data.policies_waf_request_match);

        if(policies_waf_request_match_method !== undefined && policies_waf_request_match_method !== null  && policies_waf_request_match_version !== undefined && policies_waf_request_match_version !== null  && policies_waf_request_match_path !== undefined && policies_waf_request_match_path !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });



    const [policies_authorization_action, setpolicies_authorization_action] = useState(''),
    updatepolicies_authorization_action = useCallback((evt) => setpolicies_authorization_action(evt.target.value), []);

    const [policies_authorization_host, setpolicies_authorization_host] = useState(''),
    updatepolicies_authorization_host = useCallback((evt) => setpolicies_authorization_host(evt.target.value), []);

    const [policies_authorization_name, setpolicies_authorization_name] = useState(''),
    updatepolicies_authorization_name = useCallback((evt) => {
      setpolicies_authorization_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(policies_authorizationrowData.policies_authorization, setpolicies_authorization_name_valid, setpolicies_authorization_name_invalid_text, "Policies Authorization", "name", tempId);
    }, []);

    const [policies_authorization_name_valid, setpolicies_authorization_name_valid] = useState(true);
    const [policies_authorization_name_invalid_text, setpolicies_authorization_name_invalid_text] = useState("");


    const [policies_authorization_obligation_oidc_acr_values, setpolicies_authorization_obligation_oidc_acr_values] = useState(''),
    updatepolicies_authorization_obligation_oidc_acr_values = useCallback((evt) => setpolicies_authorization_obligation_oidc_acr_values(evt.target.value), []);

    const [policies_authorization_obligation_oidc_max_age, setpolicies_authorization_obligation_oidc_max_age] = useState(0),
    updatepolicies_authorization_obligation_oidc_max_age = useCallback((evt) => {}, []);

    const [policies_authorization_obligation_oidc_prompt, setpolicies_authorization_obligation_oidc_prompt] = useState(''),
    updatepolicies_authorization_obligation_oidc_prompt = useCallback((evt) => setpolicies_authorization_obligation_oidc_prompt(evt.target.value), []);

    const [policies_authorization_obligation_redirect_url, setpolicies_authorization_obligation_redirect_url] = useState(''),
    updatepolicies_authorization_obligation_redirect_url = useCallback((evt) => setpolicies_authorization_obligation_redirect_url(evt.target.value), []);

    const [policies_authorization_rule, setpolicies_authorization_rule] = useState(''),
    updatepolicies_authorization_rule = useCallback((evt) => setpolicies_authorization_rule(evt.target.value), []);

    const [policies_content_injection_content, setpolicies_content_injection_content] = useState(''),
    updatepolicies_content_injection_content = useCallback((evt) => setpolicies_content_injection_content(evt.target.value), []);

    const [policies_content_injection_full_line_match, setpolicies_content_injection_full_line_match] = useState(true),
    updatepolicies_content_injection_full_line_match = useCallback((evt) => setpolicies_content_injection_full_line_match(evt), []);

    const [policies_content_injection_location, setpolicies_content_injection_location] = useState(''),
    updatepolicies_content_injection_location = useCallback((evt) => setpolicies_content_injection_location(evt.target.value), []);

    const [policies_content_injection_name, setpolicies_content_injection_name] = useState(''),
    updatepolicies_content_injection_name = useCallback((evt) => {
      setpolicies_content_injection_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(policies_content_injectionrowData.policies_content_injection, setpolicies_content_injection_name_valid, setpolicies_content_injection_name_invalid_text, "Policies Content Injection", "name", tempId);
    }, []);

    const [policies_content_injection_name_valid, setpolicies_content_injection_name_valid] = useState(true);
    const [policies_content_injection_name_invalid_text, setpolicies_content_injection_name_invalid_text] = useState("");


    const [policies_content_injection_replace_match, setpolicies_content_injection_replace_match] = useState(false),
    updatepolicies_content_injection_replace_match = useCallback((evt) => setpolicies_content_injection_replace_match(evt), []);

    const [policies_cors_host, setpolicies_cors_host] = useState(''),
    updatepolicies_cors_host = useCallback((evt) => setpolicies_cors_host(evt.target.value), []);

    const [policies_cors_method, setpolicies_cors_method] = useState(''),
    updatepolicies_cors_method = useCallback((evt) => setpolicies_cors_method(evt.target.value), []);

    const [policies_cors_name, setpolicies_cors_name] = useState(''),
    updatepolicies_cors_name = useCallback((evt) => {
      setpolicies_cors_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(policies_corsrowData.policies_cors, setpolicies_cors_name_valid, setpolicies_cors_name_invalid_text, "Policies Cors", "name", tempId);
    }, []);

    const [policies_cors_name_valid, setpolicies_cors_name_valid] = useState(true);
    const [policies_cors_name_invalid_text, setpolicies_cors_name_invalid_text] = useState("");


    const [policies_cors_policy_allow_credentials, setpolicies_cors_policy_allow_credentials] = useState(false),
    updatepolicies_cors_policy_allow_credentials = useCallback((evt) => setpolicies_cors_policy_allow_credentials(evt), []);

    const [policies_cors_policy_handle_pre_flight, setpolicies_cors_policy_handle_pre_flight] = useState(false),
    updatepolicies_cors_policy_handle_pre_flight = useCallback((evt) => setpolicies_cors_policy_handle_pre_flight(evt), []);

    const [policies_cors_policy_max_age, setpolicies_cors_policy_max_age] = useState(-1),
    updatepolicies_cors_policy_max_age = useCallback((evt) => {}, []);

    const [policies_http_transformations_postauthn_host, setpolicies_http_transformations_postauthn_host] = useState(''),
    updatepolicies_http_transformations_postauthn_host = useCallback((evt) => setpolicies_http_transformations_postauthn_host(evt.target.value), []);

    const [policies_http_transformations_postauthn_name, setpolicies_http_transformations_postauthn_name] = useState(''),
    updatepolicies_http_transformations_postauthn_name = useCallback((evt) => {
      setpolicies_http_transformations_postauthn_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn, setpolicies_http_transformations_postauthn_name_valid, setpolicies_http_transformations_postauthn_name_invalid_text, "Policies Http Transformations Postauthn", "name", tempId);
    }, []);

    const [policies_http_transformations_postauthn_name_valid, setpolicies_http_transformations_postauthn_name_valid] = useState(true);
    const [policies_http_transformations_postauthn_name_invalid_text, setpolicies_http_transformations_postauthn_name_invalid_text] = useState("");


    const [policies_http_transformations_postauthn_rule, setpolicies_http_transformations_postauthn_rule] = useState(''),
    updatepolicies_http_transformations_postauthn_rule = useCallback((evt) => setpolicies_http_transformations_postauthn_rule(evt.target.value), []);

    const [policies_http_transformations_postazn_host, setpolicies_http_transformations_postazn_host] = useState(''),
    updatepolicies_http_transformations_postazn_host = useCallback((evt) => setpolicies_http_transformations_postazn_host(evt.target.value), []);

    const [policies_http_transformations_postazn_method, setpolicies_http_transformations_postazn_method] = useState(''),
    updatepolicies_http_transformations_postazn_method = useCallback((evt) => setpolicies_http_transformations_postazn_method(evt.target.value), []);

    const [policies_http_transformations_postazn_name, setpolicies_http_transformations_postazn_name] = useState(''),
    updatepolicies_http_transformations_postazn_name = useCallback((evt) => {
      setpolicies_http_transformations_postazn_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(policies_http_transformations_postaznrowData.policies_http_transformations_postazn, setpolicies_http_transformations_postazn_name_valid, setpolicies_http_transformations_postazn_name_invalid_text, "Policies Http Transformations Postazn", "name", tempId);
    }, []);

    const [policies_http_transformations_postazn_name_valid, setpolicies_http_transformations_postazn_name_valid] = useState(true);
    const [policies_http_transformations_postazn_name_invalid_text, setpolicies_http_transformations_postazn_name_invalid_text] = useState("");


    const [policies_http_transformations_postazn_rule, setpolicies_http_transformations_postazn_rule] = useState(''),
    updatepolicies_http_transformations_postazn_rule = useCallback((evt) => setpolicies_http_transformations_postazn_rule(evt.target.value), []);

    const [policies_http_transformations_preazn_host, setpolicies_http_transformations_preazn_host] = useState(''),
    updatepolicies_http_transformations_preazn_host = useCallback((evt) => setpolicies_http_transformations_preazn_host(evt.target.value), []);

    const [policies_http_transformations_preazn_method, setpolicies_http_transformations_preazn_method] = useState(''),
    updatepolicies_http_transformations_preazn_method = useCallback((evt) => setpolicies_http_transformations_preazn_method(evt.target.value), []);

    const [policies_http_transformations_preazn_name, setpolicies_http_transformations_preazn_name] = useState(''),
    updatepolicies_http_transformations_preazn_name = useCallback((evt) => {
      setpolicies_http_transformations_preazn_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(policies_http_transformations_preaznrowData.policies_http_transformations_preazn, setpolicies_http_transformations_preazn_name_valid, setpolicies_http_transformations_preazn_name_invalid_text, "Policies Http Transformations Preazn", "name", tempId);
    }, []);

    const [policies_http_transformations_preazn_name_valid, setpolicies_http_transformations_preazn_name_valid] = useState(true);
    const [policies_http_transformations_preazn_name_invalid_text, setpolicies_http_transformations_preazn_name_invalid_text] = useState("");


    const [policies_http_transformations_preazn_rule, setpolicies_http_transformations_preazn_rule] = useState(''),
    updatepolicies_http_transformations_preazn_rule = useCallback((evt) => setpolicies_http_transformations_preazn_rule(evt.target.value), []);

    const [policies_http_transformations_request_host, setpolicies_http_transformations_request_host] = useState(''),
    updatepolicies_http_transformations_request_host = useCallback((evt) => setpolicies_http_transformations_request_host(evt.target.value), []);

    const [policies_http_transformations_request_method, setpolicies_http_transformations_request_method] = useState(''),
    updatepolicies_http_transformations_request_method = useCallback((evt) => setpolicies_http_transformations_request_method(evt.target.value), []);

    const [policies_http_transformations_request_name, setpolicies_http_transformations_request_name] = useState(''),
    updatepolicies_http_transformations_request_name = useCallback((evt) => {
      setpolicies_http_transformations_request_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(policies_http_transformations_requestrowData.policies_http_transformations_request, setpolicies_http_transformations_request_name_valid, setpolicies_http_transformations_request_name_invalid_text, "Policies Http Transformations Request", "name", tempId);
    }, []);

    const [policies_http_transformations_request_name_valid, setpolicies_http_transformations_request_name_valid] = useState(true);
    const [policies_http_transformations_request_name_invalid_text, setpolicies_http_transformations_request_name_invalid_text] = useState("");


    const [policies_http_transformations_request_rule, setpolicies_http_transformations_request_rule] = useState(''),
    updatepolicies_http_transformations_request_rule = useCallback((evt) => setpolicies_http_transformations_request_rule(evt.target.value), []);

    const [policies_http_transformations_response_host, setpolicies_http_transformations_response_host] = useState(''),
    updatepolicies_http_transformations_response_host = useCallback((evt) => setpolicies_http_transformations_response_host(evt.target.value), []);

    const [policies_http_transformations_response_method, setpolicies_http_transformations_response_method] = useState(''),
    updatepolicies_http_transformations_response_method = useCallback((evt) => setpolicies_http_transformations_response_method(evt.target.value), []);

    const [policies_http_transformations_response_name, setpolicies_http_transformations_response_name] = useState(''),
    updatepolicies_http_transformations_response_name = useCallback((evt) => {
      setpolicies_http_transformations_response_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(policies_http_transformations_responserowData.policies_http_transformations_response, setpolicies_http_transformations_response_name_valid, setpolicies_http_transformations_response_name_invalid_text, "Policies Http Transformations Response", "name", tempId);
    }, []);

    const [policies_http_transformations_response_name_valid, setpolicies_http_transformations_response_name_valid] = useState(true);
    const [policies_http_transformations_response_name_invalid_text, setpolicies_http_transformations_response_name_invalid_text] = useState("");


    const [policies_http_transformations_response_rule, setpolicies_http_transformations_response_rule] = useState(''),
    updatepolicies_http_transformations_response_rule = useCallback((evt) => setpolicies_http_transformations_response_rule(evt.target.value), []);

    const [policies_http_transformations_secrets_name, setpolicies_http_transformations_secrets_name] = useState(''),
    updatepolicies_http_transformations_secrets_name = useCallback((evt) => {
      setpolicies_http_transformations_secrets_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(policies_http_transformations_secretsrowData.policies_http_transformations_secrets, setpolicies_http_transformations_secrets_name_valid, setpolicies_http_transformations_secrets_name_invalid_text, "Policies Http Transformations Secrets", "name", tempId);
    }, []);

    const [policies_http_transformations_secrets_name_valid, setpolicies_http_transformations_secrets_name_valid] = useState(true);
    const [policies_http_transformations_secrets_name_invalid_text, setpolicies_http_transformations_secrets_name_invalid_text] = useState("");


    const [policies_http_transformations_secrets_value, setpolicies_http_transformations_secrets_value] = useState(''),
    updatepolicies_http_transformations_secrets_value = useCallback((evt) => setpolicies_http_transformations_secrets_value(evt.target.value), []);

    const [policies_rate_limiting_name, setpolicies_rate_limiting_name] = useState(''),
    updatepolicies_rate_limiting_name = useCallback((evt) => {
      setpolicies_rate_limiting_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(policies_rate_limitingrowData.policies_rate_limiting, setpolicies_rate_limiting_name_valid, setpolicies_rate_limiting_name_invalid_text, "Policies Rate Limiting", "name", tempId);
    }, []);

    const [policies_rate_limiting_name_valid, setpolicies_rate_limiting_name_valid] = useState(true);
    const [policies_rate_limiting_name_invalid_text, setpolicies_rate_limiting_name_invalid_text] = useState("");


    const [policies_rate_limiting_rule, setpolicies_rate_limiting_rule] = useState(''),
    updatepolicies_rate_limiting_rule = useCallback((evt) => setpolicies_rate_limiting_rule(evt.target.value), []);

    const [policies_waf_configuration_content, setpolicies_waf_configuration_content] = useState(''),
    updatepolicies_waf_configuration_content = useCallback((evt) => setpolicies_waf_configuration_content(evt.target.value), []);

    const [policies_waf_configuration_type, setpolicies_waf_configuration_type] = useState(''),
    updatepolicies_waf_configuration_type = useCallback((evt) => setpolicies_waf_configuration_type(evt.target.value), []);

    const [policies_waf_request_match_method, setpolicies_waf_request_match_method] = useState(''),
    updatepolicies_waf_request_match_method = useCallback((evt) => {
      setpolicies_waf_request_match_method(evt.target.value);
      var versionWdgt = document.getElementById("policies_waf_request_match_version_id" + idPrefix);
      var versionVal = (versionWdgt)?versionWdgt.value:"";
      var pathWdgt = document.getElementById("policies_waf_request_match_path_id" + idPrefix);
      var pathVal = (pathWdgt)?pathWdgt.value:"";
      var tempId = evt.target.value + versionVal + pathVal;
      validateField(policies_waf_request_matchrowData.policies_waf_request_match, setpolicies_waf_request_match_version_valid, setpolicies_waf_request_match_version_invalid_text, "Policies Waf Request Match", "unique values", tempId);
      validateField(policies_waf_request_matchrowData.policies_waf_request_match, setpolicies_waf_request_match_path_valid, setpolicies_waf_request_match_path_invalid_text, "Policies Waf Request Match", "unique values", tempId);
      validateField(policies_waf_request_matchrowData.policies_waf_request_match, setpolicies_waf_request_match_method_valid, setpolicies_waf_request_match_method_invalid_text, "Policies Waf Request Match", "unique values", tempId);
    }, []);

    const [policies_waf_request_match_method_valid, setpolicies_waf_request_match_method_valid] = useState(true);
    const [policies_waf_request_match_method_invalid_text, setpolicies_waf_request_match_method_invalid_text] = useState("");


    const [policies_waf_request_match_path, setpolicies_waf_request_match_path] = useState(''),
    updatepolicies_waf_request_match_path = useCallback((evt) => {
      setpolicies_waf_request_match_path(evt.target.value);
      var methodWdgt = document.getElementById("policies_waf_request_match_method_id" + idPrefix);
      var methodVal = (methodWdgt)?methodWdgt.value:"";
      var versionWdgt = document.getElementById("policies_waf_request_match_version_id" + idPrefix);
      var versionVal = (versionWdgt)?versionWdgt.value:"";
      var tempId = methodVal + versionVal + evt.target.value;
      validateField(policies_waf_request_matchrowData.policies_waf_request_match, setpolicies_waf_request_match_method_valid, setpolicies_waf_request_match_method_invalid_text, "Policies Waf Request Match", "unique values", tempId);
      validateField(policies_waf_request_matchrowData.policies_waf_request_match, setpolicies_waf_request_match_version_valid, setpolicies_waf_request_match_version_invalid_text, "Policies Waf Request Match", "unique values", tempId);
      validateField(policies_waf_request_matchrowData.policies_waf_request_match, setpolicies_waf_request_match_path_valid, setpolicies_waf_request_match_path_invalid_text, "Policies Waf Request Match", "unique values", tempId);
    }, []);

    const [policies_waf_request_match_path_valid, setpolicies_waf_request_match_path_valid] = useState(true);
    const [policies_waf_request_match_path_invalid_text, setpolicies_waf_request_match_path_invalid_text] = useState("");


    const [policies_waf_request_match_phases_logging, setpolicies_waf_request_match_phases_logging] = useState(true),
    updatepolicies_waf_request_match_phases_logging = useCallback((evt) => setpolicies_waf_request_match_phases_logging(evt), []);

    const [policies_waf_request_match_phases_request_body, setpolicies_waf_request_match_phases_request_body] = useState(true),
    updatepolicies_waf_request_match_phases_request_body = useCallback((evt) => setpolicies_waf_request_match_phases_request_body(evt), []);

    const [policies_waf_request_match_phases_request_headers, setpolicies_waf_request_match_phases_request_headers] = useState(true),
    updatepolicies_waf_request_match_phases_request_headers = useCallback((evt) => setpolicies_waf_request_match_phases_request_headers(evt), []);

    const [policies_waf_request_match_phases_response_body, setpolicies_waf_request_match_phases_response_body] = useState(true),
    updatepolicies_waf_request_match_phases_response_body = useCallback((evt) => setpolicies_waf_request_match_phases_response_body(evt), []);

    const [policies_waf_request_match_phases_response_headers, setpolicies_waf_request_match_phases_response_headers] = useState(true),
    updatepolicies_waf_request_match_phases_response_headers = useCallback((evt) => setpolicies_waf_request_match_phases_response_headers(evt), []);

    const [policies_waf_request_match_version, setpolicies_waf_request_match_version] = useState('*'),
    updatepolicies_waf_request_match_version = useCallback((evt) => {
      setpolicies_waf_request_match_version(evt.target.value);
      var methodWdgt = document.getElementById("policies_waf_request_match_method_id" + idPrefix);
      var methodVal = (methodWdgt)?methodWdgt.value:"";
      var pathWdgt = document.getElementById("policies_waf_request_match_path_id" + idPrefix);
      var pathVal = (pathWdgt)?pathWdgt.value:"";
      var tempId = methodVal + evt.target.value + pathVal;
      validateField(policies_waf_request_matchrowData.policies_waf_request_match, setpolicies_waf_request_match_method_valid, setpolicies_waf_request_match_method_invalid_text, "Policies Waf Request Match", "unique values", tempId);
      validateField(policies_waf_request_matchrowData.policies_waf_request_match, setpolicies_waf_request_match_path_valid, setpolicies_waf_request_match_path_invalid_text, "Policies Waf Request Match", "unique values", tempId);
      validateField(policies_waf_request_matchrowData.policies_waf_request_match, setpolicies_waf_request_match_version_valid, setpolicies_waf_request_match_version_invalid_text, "Policies Waf Request Match", "unique values", tempId);
    }, []);

    const [policies_waf_request_match_version_valid, setpolicies_waf_request_match_version_valid] = useState(true);
    const [policies_waf_request_match_version_invalid_text, setpolicies_waf_request_match_version_invalid_text] = useState("");


    const [policies_waf_rules_content, setpolicies_waf_rules_content] = useState(''),
    updatepolicies_waf_rules_content = useCallback((evt) => setpolicies_waf_rules_content(evt.target.value), []);

    const [policies_waf_rules_type, setpolicies_waf_rules_type] = useState(''),
    updatepolicies_waf_rules_type = useCallback((evt) => setpolicies_waf_rules_type(evt.target.value), []);


  if(window.iagpage != "PoliciesPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "PoliciesPage";
  }

    const [fetcheddata, setFetcheddata] = React.useState(false);
    React.useEffect(() => {
      dataLoad();
    }, [fetcheddata]);
    const dataLoad = () => {
      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

      for(var i = 0; i < policies_authorizationrowData.policies_authorization.length; i++) {
        if(policies_authorizationrowData.policies_authorization[i].id === window.policies_authorizationrowId) {
        setpolicies_authorization_action((policies_authorizationrowData.policies_authorization[i] !== undefined && policies_authorizationrowData.policies_authorization[i].action !== undefined )?policies_authorizationrowData.policies_authorization[i].action:"");
        setpolicies_authorization_host((policies_authorizationrowData.policies_authorization[i] !== undefined && policies_authorizationrowData.policies_authorization[i].host !== undefined )?policies_authorizationrowData.policies_authorization[i].host:"");
        setpolicies_authorization_name((policies_authorizationrowData.policies_authorization[i] !== undefined && policies_authorizationrowData.policies_authorization[i].name !== undefined )?policies_authorizationrowData.policies_authorization[i].name:"");
        setpolicies_authorization_obligation_oidc_acr_values((policies_authorizationrowData.policies_authorization[i] !== undefined && policies_authorizationrowData.policies_authorization[i].obligation !== undefined && policies_authorizationrowData.policies_authorization[i].obligation.oidc !== undefined && policies_authorizationrowData.policies_authorization[i].obligation.oidc.acr_values !== undefined )?policies_authorizationrowData.policies_authorization[i].obligation.oidc.acr_values:"");
        setpolicies_authorization_obligation_oidc_max_age((policies_authorizationrowData.policies_authorization[i] !== undefined && policies_authorizationrowData.policies_authorization[i].obligation !== undefined && policies_authorizationrowData.policies_authorization[i].obligation.oidc !== undefined && policies_authorizationrowData.policies_authorization[i].obligation.oidc.max_age !== undefined )?policies_authorizationrowData.policies_authorization[i].obligation.oidc.max_age:"");
        setpolicies_authorization_obligation_oidc_prompt((policies_authorizationrowData.policies_authorization[i] !== undefined && policies_authorizationrowData.policies_authorization[i].obligation !== undefined && policies_authorizationrowData.policies_authorization[i].obligation.oidc !== undefined && policies_authorizationrowData.policies_authorization[i].obligation.oidc.prompt !== undefined )?policies_authorizationrowData.policies_authorization[i].obligation.oidc.prompt:"");
        setpolicies_authorization_obligation_redirect_url((policies_authorizationrowData.policies_authorization[i] !== undefined && policies_authorizationrowData.policies_authorization[i].obligation !== undefined && policies_authorizationrowData.policies_authorization[i].obligation.redirect_url !== undefined )?policies_authorizationrowData.policies_authorization[i].obligation.redirect_url:"");
        setpolicies_authorization_rule((policies_authorizationrowData.policies_authorization[i] !== undefined && policies_authorizationrowData.policies_authorization[i].rule !== undefined )?policies_authorizationrowData.policies_authorization[i].rule:"");
        }
      }

      for(var i = 0; i < policies_content_injectionrowData.policies_content_injection.length; i++) {
        if(policies_content_injectionrowData.policies_content_injection[i].id === window.policies_content_injectionrowId) {
        setpolicies_content_injection_content((policies_content_injectionrowData.policies_content_injection[i] !== undefined && policies_content_injectionrowData.policies_content_injection[i].content !== undefined )?policies_content_injectionrowData.policies_content_injection[i].content:"");
        setpolicies_content_injection_full_line_match((policies_content_injectionrowData.policies_content_injection[i] !== undefined && policies_content_injectionrowData.policies_content_injection[i].full_line_match !== undefined )?(policies_content_injectionrowData.policies_content_injection[i].full_line_match == true || policies_content_injectionrowData.policies_content_injection[i].full_line_match == "true"):false);
        setpolicies_content_injection_location((policies_content_injectionrowData.policies_content_injection[i] !== undefined && policies_content_injectionrowData.policies_content_injection[i].location !== undefined )?policies_content_injectionrowData.policies_content_injection[i].location:"");
        setpolicies_content_injection_name((policies_content_injectionrowData.policies_content_injection[i] !== undefined && policies_content_injectionrowData.policies_content_injection[i].name !== undefined )?policies_content_injectionrowData.policies_content_injection[i].name:"");
        setpolicies_content_injection_replace_match((policies_content_injectionrowData.policies_content_injection[i] !== undefined && policies_content_injectionrowData.policies_content_injection[i].replace_match !== undefined )?(policies_content_injectionrowData.policies_content_injection[i].replace_match == true || policies_content_injectionrowData.policies_content_injection[i].replace_match == "true"):false);
        }
      }

      for(var i = 0; i < policies_corsrowData.policies_cors.length; i++) {
        if(policies_corsrowData.policies_cors[i].id === window.policies_corsrowId) {
        setpolicies_cors_host((policies_corsrowData.policies_cors[i] !== undefined && policies_corsrowData.policies_cors[i].host !== undefined )?policies_corsrowData.policies_cors[i].host:"");
        setpolicies_cors_method((policies_corsrowData.policies_cors[i] !== undefined && policies_corsrowData.policies_cors[i].method !== undefined )?policies_corsrowData.policies_cors[i].method:"");
        setpolicies_cors_name((policies_corsrowData.policies_cors[i] !== undefined && policies_corsrowData.policies_cors[i].name !== undefined )?policies_corsrowData.policies_cors[i].name:"");
        setpolicies_cors_policy_allow_credentials((policies_corsrowData.policies_cors[i] !== undefined && policies_corsrowData.policies_cors[i].policy !== undefined && policies_corsrowData.policies_cors[i].policy.allow_credentials !== undefined )?(policies_corsrowData.policies_cors[i].policy.allow_credentials == true || policies_corsrowData.policies_cors[i].policy.allow_credentials == "true"):false);
        setpolicies_cors_policy_handle_pre_flight((policies_corsrowData.policies_cors[i] !== undefined && policies_corsrowData.policies_cors[i].policy !== undefined && policies_corsrowData.policies_cors[i].policy.handle_pre_flight !== undefined )?(policies_corsrowData.policies_cors[i].policy.handle_pre_flight == true || policies_corsrowData.policies_cors[i].policy.handle_pre_flight == "true"):false);
        setpolicies_cors_policy_max_age((policies_corsrowData.policies_cors[i] !== undefined && policies_corsrowData.policies_cors[i].policy !== undefined && policies_corsrowData.policies_cors[i].policy.max_age !== undefined )?policies_corsrowData.policies_cors[i].policy.max_age:"");
        }
      }

      for(var i = 0; i < policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn.length; i++) {
        if(policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i].id === window.policies_http_transformations_postauthnrowId) {
        setpolicies_http_transformations_postauthn_host((policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i] !== undefined && policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i].host !== undefined )?policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i].host:"");
        setpolicies_http_transformations_postauthn_name((policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i] !== undefined && policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i].name !== undefined )?policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i].name:"");
        setpolicies_http_transformations_postauthn_rule((policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i] !== undefined && policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i].rule !== undefined )?policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn[i].rule:"");
        }
      }

      for(var i = 0; i < policies_http_transformations_postaznrowData.policies_http_transformations_postazn.length; i++) {
        if(policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i].id === window.policies_http_transformations_postaznrowId) {
        setpolicies_http_transformations_postazn_host((policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i] !== undefined && policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i].host !== undefined )?policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i].host:"");
        setpolicies_http_transformations_postazn_method((policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i] !== undefined && policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i].method !== undefined )?policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i].method:"");
        setpolicies_http_transformations_postazn_name((policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i] !== undefined && policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i].name !== undefined )?policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i].name:"");
        setpolicies_http_transformations_postazn_rule((policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i] !== undefined && policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i].rule !== undefined )?policies_http_transformations_postaznrowData.policies_http_transformations_postazn[i].rule:"");
        }
      }

      for(var i = 0; i < policies_http_transformations_preaznrowData.policies_http_transformations_preazn.length; i++) {
        if(policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i].id === window.policies_http_transformations_preaznrowId) {
        setpolicies_http_transformations_preazn_host((policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i] !== undefined && policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i].host !== undefined )?policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i].host:"");
        setpolicies_http_transformations_preazn_method((policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i] !== undefined && policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i].method !== undefined )?policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i].method:"");
        setpolicies_http_transformations_preazn_name((policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i] !== undefined && policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i].name !== undefined )?policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i].name:"");
        setpolicies_http_transformations_preazn_rule((policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i] !== undefined && policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i].rule !== undefined )?policies_http_transformations_preaznrowData.policies_http_transformations_preazn[i].rule:"");
        }
      }

      for(var i = 0; i < policies_http_transformations_requestrowData.policies_http_transformations_request.length; i++) {
        if(policies_http_transformations_requestrowData.policies_http_transformations_request[i].id === window.policies_http_transformations_requestrowId) {
        setpolicies_http_transformations_request_host((policies_http_transformations_requestrowData.policies_http_transformations_request[i] !== undefined && policies_http_transformations_requestrowData.policies_http_transformations_request[i].host !== undefined )?policies_http_transformations_requestrowData.policies_http_transformations_request[i].host:"");
        setpolicies_http_transformations_request_method((policies_http_transformations_requestrowData.policies_http_transformations_request[i] !== undefined && policies_http_transformations_requestrowData.policies_http_transformations_request[i].method !== undefined )?policies_http_transformations_requestrowData.policies_http_transformations_request[i].method:"");
        setpolicies_http_transformations_request_name((policies_http_transformations_requestrowData.policies_http_transformations_request[i] !== undefined && policies_http_transformations_requestrowData.policies_http_transformations_request[i].name !== undefined )?policies_http_transformations_requestrowData.policies_http_transformations_request[i].name:"");
        setpolicies_http_transformations_request_rule((policies_http_transformations_requestrowData.policies_http_transformations_request[i] !== undefined && policies_http_transformations_requestrowData.policies_http_transformations_request[i].rule !== undefined )?policies_http_transformations_requestrowData.policies_http_transformations_request[i].rule:"");
        }
      }

      for(var i = 0; i < policies_http_transformations_responserowData.policies_http_transformations_response.length; i++) {
        if(policies_http_transformations_responserowData.policies_http_transformations_response[i].id === window.policies_http_transformations_responserowId) {
        setpolicies_http_transformations_response_host((policies_http_transformations_responserowData.policies_http_transformations_response[i] !== undefined && policies_http_transformations_responserowData.policies_http_transformations_response[i].host !== undefined )?policies_http_transformations_responserowData.policies_http_transformations_response[i].host:"");
        setpolicies_http_transformations_response_method((policies_http_transformations_responserowData.policies_http_transformations_response[i] !== undefined && policies_http_transformations_responserowData.policies_http_transformations_response[i].method !== undefined )?policies_http_transformations_responserowData.policies_http_transformations_response[i].method:"");
        setpolicies_http_transformations_response_name((policies_http_transformations_responserowData.policies_http_transformations_response[i] !== undefined && policies_http_transformations_responserowData.policies_http_transformations_response[i].name !== undefined )?policies_http_transformations_responserowData.policies_http_transformations_response[i].name:"");
        setpolicies_http_transformations_response_rule((policies_http_transformations_responserowData.policies_http_transformations_response[i] !== undefined && policies_http_transformations_responserowData.policies_http_transformations_response[i].rule !== undefined )?policies_http_transformations_responserowData.policies_http_transformations_response[i].rule:"");
        }
      }

      for(var i = 0; i < policies_http_transformations_secretsrowData.policies_http_transformations_secrets.length; i++) {
        if(policies_http_transformations_secretsrowData.policies_http_transformations_secrets[i].id === window.policies_http_transformations_secretsrowId) {
        setpolicies_http_transformations_secrets_name((policies_http_transformations_secretsrowData.policies_http_transformations_secrets[i] !== undefined && policies_http_transformations_secretsrowData.policies_http_transformations_secrets[i].name !== undefined )?policies_http_transformations_secretsrowData.policies_http_transformations_secrets[i].name:"");
        setpolicies_http_transformations_secrets_value((policies_http_transformations_secretsrowData.policies_http_transformations_secrets[i] !== undefined && policies_http_transformations_secretsrowData.policies_http_transformations_secrets[i].value !== undefined )?policies_http_transformations_secretsrowData.policies_http_transformations_secrets[i].value:"");
        }
      }

      for(var i = 0; i < policies_rate_limitingrowData.policies_rate_limiting.length; i++) {
        if(policies_rate_limitingrowData.policies_rate_limiting[i].id === window.policies_rate_limitingrowId) {
        setpolicies_rate_limiting_name((policies_rate_limitingrowData.policies_rate_limiting[i] !== undefined && policies_rate_limitingrowData.policies_rate_limiting[i].name !== undefined )?policies_rate_limitingrowData.policies_rate_limiting[i].name:"");
        setpolicies_rate_limiting_rule((policies_rate_limitingrowData.policies_rate_limiting[i] !== undefined && policies_rate_limitingrowData.policies_rate_limiting[i].rule !== undefined )?policies_rate_limitingrowData.policies_rate_limiting[i].rule:"");
        }
      }

      for(var i = 0; i < policies_waf_request_matchrowData.policies_waf_request_match.length; i++) {
        if(policies_waf_request_matchrowData.policies_waf_request_match[i].id === window.policies_waf_request_matchrowId) {
        setpolicies_waf_request_match_method((policies_waf_request_matchrowData.policies_waf_request_match[i] !== undefined && policies_waf_request_matchrowData.policies_waf_request_match[i].method !== undefined )?policies_waf_request_matchrowData.policies_waf_request_match[i].method:"");
        setpolicies_waf_request_match_path((policies_waf_request_matchrowData.policies_waf_request_match[i] !== undefined && policies_waf_request_matchrowData.policies_waf_request_match[i].path !== undefined )?policies_waf_request_matchrowData.policies_waf_request_match[i].path:"");
        setpolicies_waf_request_match_phases_logging((policies_waf_request_matchrowData.policies_waf_request_match[i] !== undefined && policies_waf_request_matchrowData.policies_waf_request_match[i].phases !== undefined && policies_waf_request_matchrowData.policies_waf_request_match[i].phases.logging !== undefined )?(policies_waf_request_matchrowData.policies_waf_request_match[i].phases.logging == true || policies_waf_request_matchrowData.policies_waf_request_match[i].phases.logging == "true"):false);
        setpolicies_waf_request_match_phases_request_body((policies_waf_request_matchrowData.policies_waf_request_match[i] !== undefined && policies_waf_request_matchrowData.policies_waf_request_match[i].phases !== undefined && policies_waf_request_matchrowData.policies_waf_request_match[i].phases.request_body !== undefined )?(policies_waf_request_matchrowData.policies_waf_request_match[i].phases.request_body == true || policies_waf_request_matchrowData.policies_waf_request_match[i].phases.request_body == "true"):false);
        setpolicies_waf_request_match_phases_request_headers((policies_waf_request_matchrowData.policies_waf_request_match[i] !== undefined && policies_waf_request_matchrowData.policies_waf_request_match[i].phases !== undefined && policies_waf_request_matchrowData.policies_waf_request_match[i].phases.request_headers !== undefined )?(policies_waf_request_matchrowData.policies_waf_request_match[i].phases.request_headers == true || policies_waf_request_matchrowData.policies_waf_request_match[i].phases.request_headers == "true"):false);
        setpolicies_waf_request_match_phases_response_body((policies_waf_request_matchrowData.policies_waf_request_match[i] !== undefined && policies_waf_request_matchrowData.policies_waf_request_match[i].phases !== undefined && policies_waf_request_matchrowData.policies_waf_request_match[i].phases.response_body !== undefined )?(policies_waf_request_matchrowData.policies_waf_request_match[i].phases.response_body == true || policies_waf_request_matchrowData.policies_waf_request_match[i].phases.response_body == "true"):false);
        setpolicies_waf_request_match_phases_response_headers((policies_waf_request_matchrowData.policies_waf_request_match[i] !== undefined && policies_waf_request_matchrowData.policies_waf_request_match[i].phases !== undefined && policies_waf_request_matchrowData.policies_waf_request_match[i].phases.response_headers !== undefined )?(policies_waf_request_matchrowData.policies_waf_request_match[i].phases.response_headers == true || policies_waf_request_matchrowData.policies_waf_request_match[i].phases.response_headers == "true"):false);
        setpolicies_waf_request_match_version((policies_waf_request_matchrowData.policies_waf_request_match[i] !== undefined && policies_waf_request_matchrowData.policies_waf_request_match[i].version !== undefined )?policies_waf_request_matchrowData.policies_waf_request_match[i].version:"");
        }
      }


      return true;
    };
    const [fetchedpolicies, setFetchedpolicies] = React.useState(false);
    React.useEffect(() => {
      getpolicies();
    }, [fetchedpolicies]);

    const getpolicies = () => {

      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

            policies_authorizationrowData.policies_authorization = [];
            policies_content_injectionrowData.policies_content_injection = [];
            policies_corsrowData.policies_cors = [];
              policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn = [];
              policies_http_transformations_postaznrowData.policies_http_transformations_postazn = [];
              policies_http_transformations_preaznrowData.policies_http_transformations_preazn = [];
              policies_http_transformations_requestrowData.policies_http_transformations_request = [];
              policies_http_transformations_responserowData.policies_http_transformations_response = [];
              policies_http_transformations_secretsrowData.policies_http_transformations_secrets = [];
            policies_rate_limitingrowData.policies_rate_limiting = [];
              policies_waf_request_matchrowData.policies_waf_request_match = [];

        if(json !== undefined && json.policies !== undefined ) {
          if(json !== undefined && json.policies !== undefined && json.policies.authorization !== undefined ) {
            var newauthorizations = [];
            for(var i = 0; i < json.policies.authorization.length; i++) {
              var newItem = {};
              var tempId = ((json.policies.authorization[i].name)?json.policies.authorization[i].name:"");
              newItem["id"] = tempId;
              newItem["action"] = json.policies.authorization[i].action;
              newItem["host"] = json.policies.authorization[i].host;
              if(json !== undefined && json.policies !== undefined && json.policies.authorization[i] !== undefined && json.policies.authorization[i].methods !== undefined ) {
                var newmethodss = [];
                for(var i2 = 0; i2 < json.policies.authorization[i].methods.length; i2++) {
                    var newmethods = {};
                    newmethods["id"] = json.policies.authorization[i].methods[i2];
                    newmethods["methods"] = json.policies.authorization[i].methods[i2];
                    newmethodss.push(newmethods);
                }
                newItem["methods"] = newmethodss;
                }
              newItem["name"] = json.policies.authorization[i].name;
              var newobligation = {};
              if(json !== undefined && json.policies !== undefined && json.policies.authorization[i] !== undefined && json.policies.authorization[i].obligation !== undefined ) {
                var newoidc = {};
                if(json !== undefined && json.policies !== undefined && json.policies.authorization[i] !== undefined && json.policies.authorization[i].obligation !== undefined && json.policies.authorization[i].obligation.oidc !== undefined ) {
                  newoidc["acr_values"] = json.policies.authorization[i].obligation.oidc.acr_values;
                  newoidc["max_age"] = json.policies.authorization[i].obligation.oidc.max_age;
                  newoidc["prompt"] = json.policies.authorization[i].obligation.oidc.prompt;
                }
                newobligation["oidc"] = newoidc;
                newobligation["redirect_url"] = json.policies.authorization[i].obligation.redirect_url;
              }
              newItem["obligation"] = newobligation;
              if(json !== undefined && json.policies !== undefined && json.policies.authorization[i] !== undefined && json.policies.authorization[i].paths !== undefined ) {
                var newpathss = [];
                for(var i2 = 0; i2 < json.policies.authorization[i].paths.length; i2++) {
                    var newpaths = {};
                    newpaths["id"] = json.policies.authorization[i].paths[i2];
                    newpaths["paths"] = json.policies.authorization[i].paths[i2];
                    newpathss.push(newpaths);
                }
                newItem["paths"] = newpathss;
                }
              newItem["rule"] = json.policies.authorization[i].rule;
              policies_authorizationrowData.policies_authorization.push(newItem);
            }
            }
          if(json !== undefined && json.policies !== undefined && json.policies.content_injection !== undefined ) {
            var newcontent_injections = [];
            for(var i = 0; i < json.policies.content_injection.length; i++) {
              var newItem = {};
              var tempId = ((json.policies.content_injection[i].name)?json.policies.content_injection[i].name:"");
              newItem["id"] = tempId;
              newItem["content"] = json.policies.content_injection[i].content;
              newItem["full_line_match"] = json.policies.content_injection[i].full_line_match;
              newItem["location"] = json.policies.content_injection[i].location;
              newItem["name"] = json.policies.content_injection[i].name;
              if(json !== undefined && json.policies !== undefined && json.policies.content_injection[i] !== undefined && json.policies.content_injection[i].paths !== undefined ) {
                var newpathss = [];
                for(var i2 = 0; i2 < json.policies.content_injection[i].paths.length; i2++) {
                    var newpaths = {};
                    newpaths["id"] = json.policies.content_injection[i].paths[i2];
                    newpaths["paths"] = json.policies.content_injection[i].paths[i2];
                    newpathss.push(newpaths);
                }
                newItem["paths"] = newpathss;
                }
              newItem["replace_match"] = json.policies.content_injection[i].replace_match;
              policies_content_injectionrowData.policies_content_injection.push(newItem);
            }
            }
          if(json !== undefined && json.policies !== undefined && json.policies.cors !== undefined ) {
            var newcorss = [];
            for(var i = 0; i < json.policies.cors.length; i++) {
              var newItem = {};
              var tempId = ((json.policies.cors[i].name)?json.policies.cors[i].name:"");
              newItem["id"] = tempId;
              newItem["host"] = json.policies.cors[i].host;
              newItem["method"] = json.policies.cors[i].method;
              newItem["name"] = json.policies.cors[i].name;
              if(json !== undefined && json.policies !== undefined && json.policies.cors[i] !== undefined && json.policies.cors[i].paths !== undefined ) {
                var newpathss = [];
                for(var i2 = 0; i2 < json.policies.cors[i].paths.length; i2++) {
                    var newpaths = {};
                    newpaths["id"] = json.policies.cors[i].paths[i2];
                    newpaths["paths"] = json.policies.cors[i].paths[i2];
                    newpathss.push(newpaths);
                }
                newItem["paths"] = newpathss;
                }
              var newpolicy = {};
              if(json !== undefined && json.policies !== undefined && json.policies.cors[i] !== undefined && json.policies.cors[i].policy !== undefined ) {
                newpolicy["allow_credentials"] = json.policies.cors[i].policy.allow_credentials;
                if(json !== undefined && json.policies !== undefined && json.policies.cors[i] !== undefined && json.policies.cors[i].policy !== undefined && json.policies.cors[i].policy.allow_headers !== undefined ) {
                  var newallow_headerss = [];
                  for(var i2 = 0; i2 < json.policies.cors[i].policy.allow_headers.length; i2++) {
                      var newallow_headers = {};
                      newallow_headers["id"] = json.policies.cors[i].policy.allow_headers[i2];
                      newallow_headers["allow_headers"] = json.policies.cors[i].policy.allow_headers[i2];
                      newallow_headerss.push(newallow_headers);
                  }
                  newpolicy["allow_headers"] = newallow_headerss;
                  }
                if(json !== undefined && json.policies !== undefined && json.policies.cors[i] !== undefined && json.policies.cors[i].policy !== undefined && json.policies.cors[i].policy.allow_methods !== undefined ) {
                  var newallow_methodss = [];
                  for(var i2 = 0; i2 < json.policies.cors[i].policy.allow_methods.length; i2++) {
                      var newallow_methods = {};
                      newallow_methods["id"] = json.policies.cors[i].policy.allow_methods[i2];
                      newallow_methods["allow_methods"] = json.policies.cors[i].policy.allow_methods[i2];
                      newallow_methodss.push(newallow_methods);
                  }
                  newpolicy["allow_methods"] = newallow_methodss;
                  }
                if(json !== undefined && json.policies !== undefined && json.policies.cors[i] !== undefined && json.policies.cors[i].policy !== undefined && json.policies.cors[i].policy.allow_origins !== undefined ) {
                  var newallow_originss = [];
                  for(var i2 = 0; i2 < json.policies.cors[i].policy.allow_origins.length; i2++) {
                      var newallow_origins = {};
                      newallow_origins["id"] = json.policies.cors[i].policy.allow_origins[i2];
                      newallow_origins["allow_origins"] = json.policies.cors[i].policy.allow_origins[i2];
                      newallow_originss.push(newallow_origins);
                  }
                  newpolicy["allow_origins"] = newallow_originss;
                  }
                if(json !== undefined && json.policies !== undefined && json.policies.cors[i] !== undefined && json.policies.cors[i].policy !== undefined && json.policies.cors[i].policy.expose_headers !== undefined ) {
                  var newexpose_headerss = [];
                  for(var i2 = 0; i2 < json.policies.cors[i].policy.expose_headers.length; i2++) {
                      var newexpose_headers = {};
                      newexpose_headers["id"] = json.policies.cors[i].policy.expose_headers[i2];
                      newexpose_headers["expose_headers"] = json.policies.cors[i].policy.expose_headers[i2];
                      newexpose_headerss.push(newexpose_headers);
                  }
                  newpolicy["expose_headers"] = newexpose_headerss;
                  }
                newpolicy["handle_pre_flight"] = json.policies.cors[i].policy.handle_pre_flight;
                newpolicy["max_age"] = json.policies.cors[i].policy.max_age;
              }
              newItem["policy"] = newpolicy;
              policies_corsrowData.policies_cors.push(newItem);
            }
            }
          var newhttp_transformations = {};
          if(json !== undefined && json.policies !== undefined && json.policies.http_transformations !== undefined ) {
            if(json !== undefined && json.policies !== undefined && json.policies.http_transformations !== undefined && json.policies.http_transformations.postauthn !== undefined ) {
              var newpostauthns = [];
              for(var i = 0; i < json.policies.http_transformations.postauthn.length; i++) {
                var newhttp_transformations = {};
                if(json !== undefined && json.policies !== undefined && json.policies.http_transformations !== undefined && json.policies.http_transformations.postauthn[i] !== undefined && json.policies.http_transformations.postauthn[i].authentication_mechanisms !== undefined ) {
                  var newauthentication_mechanismss = [];
                  for(var i2 = 0; i2 < json.policies.http_transformations.postauthn[i].authentication_mechanisms.length; i2++) {
                      var newauthentication_mechanisms = {};
                      newauthentication_mechanisms["id"] = json.policies.http_transformations.postauthn[i].authentication_mechanisms[i2];
                      newauthentication_mechanisms["authentication_mechanisms"] = json.policies.http_transformations.postauthn[i].authentication_mechanisms[i2];
                      newauthentication_mechanismss.push(newauthentication_mechanisms);
                  }
                  newhttp_transformations["authentication_mechanisms"] = newauthentication_mechanismss;
                  }
                var tempId = ((json.policies.http_transformations.postauthn[i].name)?json.policies.http_transformations.postauthn[i].name:"");
                newhttp_transformations["id"] = tempId;
                newhttp_transformations["host"] = json.policies.http_transformations.postauthn[i].host;
                newhttp_transformations["name"] = json.policies.http_transformations.postauthn[i].name;
                newhttp_transformations["rule"] = json.policies.http_transformations.postauthn[i].rule;
              }
              policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn.push(newhttp_transformations);
              }
            if(json !== undefined && json.policies !== undefined && json.policies.http_transformations !== undefined && json.policies.http_transformations.postazn !== undefined ) {
              var newpostazns = [];
              for(var i = 0; i < json.policies.http_transformations.postazn.length; i++) {
                var newhttp_transformations = {};
                var tempId = ((json.policies.http_transformations.postazn[i].name)?json.policies.http_transformations.postazn[i].name:"");
                newhttp_transformations["id"] = tempId;
                newhttp_transformations["host"] = json.policies.http_transformations.postazn[i].host;
                newhttp_transformations["method"] = json.policies.http_transformations.postazn[i].method;
                newhttp_transformations["name"] = json.policies.http_transformations.postazn[i].name;
                if(json !== undefined && json.policies !== undefined && json.policies.http_transformations !== undefined && json.policies.http_transformations.postazn[i] !== undefined && json.policies.http_transformations.postazn[i].paths !== undefined ) {
                  var newpathss = [];
                  for(var i2 = 0; i2 < json.policies.http_transformations.postazn[i].paths.length; i2++) {
                      var newpaths = {};
                      newpaths["id"] = json.policies.http_transformations.postazn[i].paths[i2];
                      newpaths["paths"] = json.policies.http_transformations.postazn[i].paths[i2];
                      newpathss.push(newpaths);
                  }
                  newhttp_transformations["paths"] = newpathss;
                  }
                newhttp_transformations["rule"] = json.policies.http_transformations.postazn[i].rule;
              }
              policies_http_transformations_postaznrowData.policies_http_transformations_postazn.push(newhttp_transformations);
              }
            if(json !== undefined && json.policies !== undefined && json.policies.http_transformations !== undefined && json.policies.http_transformations.preazn !== undefined ) {
              var newpreazns = [];
              for(var i = 0; i < json.policies.http_transformations.preazn.length; i++) {
                var newhttp_transformations = {};
                var tempId = ((json.policies.http_transformations.preazn[i].name)?json.policies.http_transformations.preazn[i].name:"");
                newhttp_transformations["id"] = tempId;
                newhttp_transformations["host"] = json.policies.http_transformations.preazn[i].host;
                newhttp_transformations["method"] = json.policies.http_transformations.preazn[i].method;
                newhttp_transformations["name"] = json.policies.http_transformations.preazn[i].name;
                if(json !== undefined && json.policies !== undefined && json.policies.http_transformations !== undefined && json.policies.http_transformations.preazn[i] !== undefined && json.policies.http_transformations.preazn[i].paths !== undefined ) {
                  var newpathss = [];
                  for(var i2 = 0; i2 < json.policies.http_transformations.preazn[i].paths.length; i2++) {
                      var newpaths = {};
                      newpaths["id"] = json.policies.http_transformations.preazn[i].paths[i2];
                      newpaths["paths"] = json.policies.http_transformations.preazn[i].paths[i2];
                      newpathss.push(newpaths);
                  }
                  newhttp_transformations["paths"] = newpathss;
                  }
                newhttp_transformations["rule"] = json.policies.http_transformations.preazn[i].rule;
              }
              policies_http_transformations_preaznrowData.policies_http_transformations_preazn.push(newhttp_transformations);
              }
            if(json !== undefined && json.policies !== undefined && json.policies.http_transformations !== undefined && json.policies.http_transformations.request !== undefined ) {
              var newrequests = [];
              for(var i = 0; i < json.policies.http_transformations.request.length; i++) {
                var newhttp_transformations = {};
                var tempId = ((json.policies.http_transformations.request[i].name)?json.policies.http_transformations.request[i].name:"");
                newhttp_transformations["id"] = tempId;
                newhttp_transformations["host"] = json.policies.http_transformations.request[i].host;
                newhttp_transformations["method"] = json.policies.http_transformations.request[i].method;
                newhttp_transformations["name"] = json.policies.http_transformations.request[i].name;
                if(json !== undefined && json.policies !== undefined && json.policies.http_transformations !== undefined && json.policies.http_transformations.request[i] !== undefined && json.policies.http_transformations.request[i].paths !== undefined ) {
                  var newpathss = [];
                  for(var i2 = 0; i2 < json.policies.http_transformations.request[i].paths.length; i2++) {
                      var newpaths = {};
                      newpaths["id"] = json.policies.http_transformations.request[i].paths[i2];
                      newpaths["paths"] = json.policies.http_transformations.request[i].paths[i2];
                      newpathss.push(newpaths);
                  }
                  newhttp_transformations["paths"] = newpathss;
                  }
                newhttp_transformations["rule"] = json.policies.http_transformations.request[i].rule;
              }
              policies_http_transformations_requestrowData.policies_http_transformations_request.push(newhttp_transformations);
              }
            if(json !== undefined && json.policies !== undefined && json.policies.http_transformations !== undefined && json.policies.http_transformations.response !== undefined ) {
              var newresponses = [];
              for(var i = 0; i < json.policies.http_transformations.response.length; i++) {
                var newhttp_transformations = {};
                var tempId = ((json.policies.http_transformations.response[i].name)?json.policies.http_transformations.response[i].name:"");
                newhttp_transformations["id"] = tempId;
                newhttp_transformations["host"] = json.policies.http_transformations.response[i].host;
                newhttp_transformations["method"] = json.policies.http_transformations.response[i].method;
                newhttp_transformations["name"] = json.policies.http_transformations.response[i].name;
                if(json !== undefined && json.policies !== undefined && json.policies.http_transformations !== undefined && json.policies.http_transformations.response[i] !== undefined && json.policies.http_transformations.response[i].paths !== undefined ) {
                  var newpathss = [];
                  for(var i2 = 0; i2 < json.policies.http_transformations.response[i].paths.length; i2++) {
                      var newpaths = {};
                      newpaths["id"] = json.policies.http_transformations.response[i].paths[i2];
                      newpaths["paths"] = json.policies.http_transformations.response[i].paths[i2];
                      newpathss.push(newpaths);
                  }
                  newhttp_transformations["paths"] = newpathss;
                  }
                newhttp_transformations["rule"] = json.policies.http_transformations.response[i].rule;
              }
              policies_http_transformations_responserowData.policies_http_transformations_response.push(newhttp_transformations);
              }
            if(json !== undefined && json.policies !== undefined && json.policies.http_transformations !== undefined && json.policies.http_transformations.secrets !== undefined ) {
              var newsecretss = [];
              for(var i = 0; i < json.policies.http_transformations.secrets.length; i++) {
                var newhttp_transformations = {};
                var tempId = ((json.policies.http_transformations.secrets[i].name)?json.policies.http_transformations.secrets[i].name:"");
                newhttp_transformations["id"] = tempId;
                newhttp_transformations["name"] = json.policies.http_transformations.secrets[i].name;
                newhttp_transformations["value"] = json.policies.http_transformations.secrets[i].value;
              }
              policies_http_transformations_secretsrowData.policies_http_transformations_secrets.push(newhttp_transformations);
              }
          }
          if(json !== undefined && json.policies !== undefined && json.policies.rate_limiting !== undefined ) {
            var newrate_limitings = [];
            for(var i = 0; i < json.policies.rate_limiting.length; i++) {
              var newItem = {};
              if(json !== undefined && json.policies !== undefined && json.policies.rate_limiting[i] !== undefined && json.policies.rate_limiting[i].methods !== undefined ) {
                var newmethodss = [];
                for(var i2 = 0; i2 < json.policies.rate_limiting[i].methods.length; i2++) {
                    var newmethods = {};
                    newmethods["id"] = json.policies.rate_limiting[i].methods[i2];
                    newmethods["methods"] = json.policies.rate_limiting[i].methods[i2];
                    newmethodss.push(newmethods);
                }
                newItem["methods"] = newmethodss;
                }
              var tempId = ((json.policies.rate_limiting[i].name)?json.policies.rate_limiting[i].name:"");
              newItem["id"] = tempId;
              newItem["name"] = json.policies.rate_limiting[i].name;
              if(json !== undefined && json.policies !== undefined && json.policies.rate_limiting[i] !== undefined && json.policies.rate_limiting[i].paths !== undefined ) {
                var newpathss = [];
                for(var i2 = 0; i2 < json.policies.rate_limiting[i].paths.length; i2++) {
                    var newpaths = {};
                    newpaths["id"] = json.policies.rate_limiting[i].paths[i2];
                    newpaths["paths"] = json.policies.rate_limiting[i].paths[i2];
                    newpathss.push(newpaths);
                }
                newItem["paths"] = newpathss;
                }
              newItem["rule"] = json.policies.rate_limiting[i].rule;
              policies_rate_limitingrowData.policies_rate_limiting.push(newItem);
            }
            }
          var newwaf = {};
          if(json !== undefined && json.policies !== undefined && json.policies.waf !== undefined ) {
            var newconfiguration = {};
            if(json !== undefined && json.policies !== undefined && json.policies.waf !== undefined && json.policies.waf.configuration !== undefined ) {
              if(json !== undefined && json.policies !== undefined && json.policies.waf !== undefined && json.policies.waf.configuration !== undefined && json.policies.waf.configuration.content !== undefined ) {
                setpolicies_waf_configuration_content(json.policies.waf.configuration.content);
              }
              if(json !== undefined && json.policies !== undefined && json.policies.waf !== undefined && json.policies.waf.configuration !== undefined && json.policies.waf.configuration.type !== undefined ) {
                setpolicies_waf_configuration_type(json.policies.waf.configuration.type);
              }
            }
            newwaf["configuration"] = newconfiguration;
            if(json !== undefined && json.policies !== undefined && json.policies.waf !== undefined && json.policies.waf.request_match !== undefined ) {
              var newrequest_matchs = [];
              for(var i = 0; i < json.policies.waf.request_match.length; i++) {
                var newwaf = {};
                var tempId = ((json.policies.waf.request_match[i].method)?json.policies.waf.request_match[i].method:"") + ((json.policies.waf.request_match[i].version)?json.policies.waf.request_match[i].version:"") + ((json.policies.waf.request_match[i].path)?json.policies.waf.request_match[i].path:"");
                newwaf["id"] = tempId;
                newwaf["method"] = json.policies.waf.request_match[i].method;
                newwaf["path"] = json.policies.waf.request_match[i].path;
                var newphases = {};
                if(json !== undefined && json.policies !== undefined && json.policies.waf !== undefined && json.policies.waf.request_match[i] !== undefined && json.policies.waf.request_match[i].phases !== undefined ) {
                  newphases["logging"] = json.policies.waf.request_match[i].phases.logging;
                  newphases["request_body"] = json.policies.waf.request_match[i].phases.request_body;
                  newphases["request_headers"] = json.policies.waf.request_match[i].phases.request_headers;
                  newphases["response_body"] = json.policies.waf.request_match[i].phases.response_body;
                  newphases["response_headers"] = json.policies.waf.request_match[i].phases.response_headers;
                }
                newwaf["phases"] = newphases;
                newwaf["version"] = json.policies.waf.request_match[i].version;
              }
              policies_waf_request_matchrowData.policies_waf_request_match.push(newwaf);
              }
            var newrules = {};
            if(json !== undefined && json.policies !== undefined && json.policies.waf !== undefined && json.policies.waf.rules !== undefined ) {
              if(json !== undefined && json.policies !== undefined && json.policies.waf !== undefined && json.policies.waf.rules !== undefined && json.policies.waf.rules.content !== undefined ) {
                setpolicies_waf_rules_content(json.policies.waf.rules.content);
              }
              if(json !== undefined && json.policies !== undefined && json.policies.waf !== undefined && json.policies.waf.rules !== undefined && json.policies.waf.rules.type !== undefined ) {
                setpolicies_waf_rules_type(json.policies.waf.rules.type);
              }
            }
            newwaf["rules"] = newrules;
          }
        }
    };



    const setDataMain = (functionName, data) => {
      if(functionName && data) {
        eval(functionName)(data);
      }
    };

    return (
        <div className="bx--grid--no-gutter bx--grid--full-width landing-page">
          <div className="bx--row landing-page__banner" style={{paddingBottom:"3rem"}}>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h1 className="landing-page__heading">
                Policies
              </h1>
            </div>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h4 className="landing-page__desc" style={{marginTop:"30px"}}>The `policies` node defines the configuration of path based policies for the IBM Application Gateway.
</h4>
            </div>            <div id="warning_div" className="bx--col-lg-13" style={{display:'none', color:'red', position:'absolute', bottom:'0', marginBottom: '10px'}}></div>
          </div>
          <div className="bx--row landing-page__r2">
            <div className="bx--col bx--no-gutter">
              <div id="policiesPage" className="bx--col">
                <br/><br/><br/>
            <Tabs id={"policies_tab" + idPrefix} defaultTab={"authorization_tab" + idPrefix} vertical className="vertical-tabs" style={{overflow:'auto'}}>
              <TabList>
                <Tab tabFor={"authorization_tab" + idPrefix}>Authorization</Tab>
                <Tab tabFor={"cors_tab" + idPrefix}>CORS</Tab>
                <Tab tabFor={"content_injection_tab" + idPrefix}>Content Injection</Tab>
                <Tab tabFor={"http_transformations_tab" + idPrefix}>HTTP Transformations</Tab>
                <Tab tabFor={"rate_limiting_tab" + idPrefix}>Rate Limiting</Tab>
                <Tab tabFor={"waf_tab" + idPrefix}>Web Application Firewall</Tab>
              </TabList>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"authorization_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading policies_div" + idPrefix}>
                  <span className="iag_breadcrumb">Policies : </span><br/>                  <h2>Authorization Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div policies_div" + idPrefix}>
                <div className= {"iag_form_elem policies_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"policies_authorization_tooltip_id" + idPrefix} >Authorization</h3><hr/>
</div>
          <ReactTooltip id={"policies_authorization_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" class="tooltipScroll" delayHide={500}><div style={{ maxWidth: '50vw', maxHeight: 300, overflowY: 'scroll' }}>The gateway can apply authorization rules to incoming requests. This entry defines a list of matching requests, rules and actions to perform if matches are found. The rules can be either:<br/>  * Defined directly here in an entry.<br/>  * Defined in the authorization section and reference by name here in an entry.<br/><br/>This entry defines authorization rules directly. There are also two pre-defined rules which can be used:<br/>  * "anyuser" : Which allows access to any user, even if they are not authenticated.<br/>  * "anyauth" : Which allows access to any authenticated user.<br/></div></ReactTooltip>

                <div id={"policies_authorizationTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem policies_div" + idPrefix}>
                    <DataTable id={"policies_authorizationTable" + idPrefix} isSortable
                        headers={policies_authorizationheaderData}
                        rows={policies_authorizationrowData.policies_authorization}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {policies_authorizationhandleAdd(idPrefix, [setpolicies_authorization_action(''),    setpolicies_authorization_host(''),    setpolicies_authorization_name(''),    setpolicies_authorization_name_valid(true),    setpolicies_authorization_obligation_oidc_acr_values(''),    setpolicies_authorization_obligation_oidc_max_age(0),    setpolicies_authorization_obligation_oidc_prompt(''),    setpolicies_authorization_obligation_redirect_url(''),    setpolicies_authorization_rule(''),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <PoliciesauthorizationDeleteModal row={row} loadGrid={policies_authorizationloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <PoliciesauthorizationEdit  data={policies_authorizationrowData.policies_authorization} setData={setDataMain} row={row} loadGrid={policies_authorizationloadGrid} dataLoad={dataLoad} editing={true} name={"policies_authorization"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_authorization_action={updatepolicies_authorization_action} policies_authorization_action={policies_authorization_action}
            updatepolicies_authorization_host={updatepolicies_authorization_host} policies_authorization_host={policies_authorization_host}
            updatepolicies_authorization_name={updatepolicies_authorization_name} policies_authorization_name={policies_authorization_name}
            policies_authorization_name_valid={policies_authorization_name_valid}
            policies_authorization_name_invalid_text={policies_authorization_name_invalid_text}
            updatepolicies_authorization_obligation_oidc_acr_values={updatepolicies_authorization_obligation_oidc_acr_values} policies_authorization_obligation_oidc_acr_values={policies_authorization_obligation_oidc_acr_values}
            updatepolicies_authorization_obligation_oidc_max_age={updatepolicies_authorization_obligation_oidc_max_age} policies_authorization_obligation_oidc_max_age={policies_authorization_obligation_oidc_max_age}
            updatepolicies_authorization_obligation_oidc_prompt={updatepolicies_authorization_obligation_oidc_prompt} policies_authorization_obligation_oidc_prompt={policies_authorization_obligation_oidc_prompt}
            updatepolicies_authorization_obligation_redirect_url={updatepolicies_authorization_obligation_redirect_url} policies_authorization_obligation_redirect_url={policies_authorization_obligation_redirect_url}
            updatepolicies_authorization_rule={updatepolicies_authorization_rule} policies_authorization_rule={policies_authorization_rule}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"rate_limiting_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading policies_div" + idPrefix}>
                  <span className="iag_breadcrumb">Policies : </span><br/>                  <h2>Rate Limiting Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div policies_div" + idPrefix}>
                <div className= {"iag_form_elem policies_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"policies_rate_limiting_tooltip_id" + idPrefix} >Rate Limiting</h3><hr/>
</div>
          <ReactTooltip id={"policies_rate_limiting_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The gateway can apply rate limiting to incoming requests. This entry defines the rate limiting policies and where they will be applied. Refer to the documentation for information about how to author a rate-limiting policy.<br/>This entry is an array and can be used to define multiple policies.<br/></div></ReactTooltip>

                <div id={"policies_rate_limitingTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem policies_div" + idPrefix}>
                    <DataTable id={"policies_rate_limitingTable" + idPrefix} isSortable
                        headers={policies_rate_limitingheaderData}
                        rows={policies_rate_limitingrowData.policies_rate_limiting}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {policies_rate_limitinghandleAdd(idPrefix, [setpolicies_rate_limiting_name(''),    setpolicies_rate_limiting_name_valid(true),    setpolicies_rate_limiting_rule(''),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <PoliciesrateLimitingDeleteModal row={row} loadGrid={policies_rate_limitingloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <PoliciesrateLimitingEdit  data={policies_rate_limitingrowData.policies_rate_limiting} setData={setDataMain} row={row} loadGrid={policies_rate_limitingloadGrid} dataLoad={dataLoad} editing={true} name={"policies_rate_limiting"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_rate_limiting_name={updatepolicies_rate_limiting_name} policies_rate_limiting_name={policies_rate_limiting_name}
            policies_rate_limiting_name_valid={policies_rate_limiting_name_valid}
            policies_rate_limiting_name_invalid_text={policies_rate_limiting_name_invalid_text}
            updatepolicies_rate_limiting_rule={updatepolicies_rate_limiting_rule} policies_rate_limiting_rule={policies_rate_limiting_rule}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"cors_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading policies_div" + idPrefix}>
                  <span className="iag_breadcrumb">Policies : </span><br/>                  <h2>CORS Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div policies_div" + idPrefix}>
                <div className= {"iag_form_elem policies_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"policies_cors_tooltip_id" + idPrefix} >CORS</h3><hr/>
</div>
          <ReactTooltip id={"policies_cors_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The reverse proxy can support cross-origin resource sharing with CORS aware clients.<br/>Each defined policy must at a minimum contain:<br/>  * name<br/>  * method<br/>  * policy:allow_origins<br/><br/>This entry is an array and can be used to specify multiple CORS policies.<br/></div></ReactTooltip>

                <div id={"policies_corsTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem policies_div" + idPrefix}>
                    <DataTable id={"policies_corsTable" + idPrefix} isSortable
                        headers={policies_corsheaderData}
                        rows={policies_corsrowData.policies_cors}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {policies_corshandleAdd(idPrefix, [setpolicies_cors_host(''),    setpolicies_cors_method(''),    setpolicies_cors_name(''),    setpolicies_cors_name_valid(true),    setpolicies_cors_policy_allow_credentials(false),    setpolicies_cors_policy_handle_pre_flight(false),    setpolicies_cors_policy_max_age(-1),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <PoliciescorsDeleteModal row={row} loadGrid={policies_corsloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <PoliciescorsEdit  data={policies_corsrowData.policies_cors} setData={setDataMain} row={row} loadGrid={policies_corsloadGrid} dataLoad={dataLoad} editing={true} name={"policies_cors"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_cors_host={updatepolicies_cors_host} policies_cors_host={policies_cors_host}
            updatepolicies_cors_method={updatepolicies_cors_method} policies_cors_method={policies_cors_method}
            updatepolicies_cors_name={updatepolicies_cors_name} policies_cors_name={policies_cors_name}
            policies_cors_name_valid={policies_cors_name_valid}
            policies_cors_name_invalid_text={policies_cors_name_invalid_text}
            updatepolicies_cors_policy_allow_credentials={updatepolicies_cors_policy_allow_credentials} policies_cors_policy_allow_credentials={policies_cors_policy_allow_credentials}
            updatepolicies_cors_policy_handle_pre_flight={updatepolicies_cors_policy_handle_pre_flight} policies_cors_policy_handle_pre_flight={policies_cors_policy_handle_pre_flight}
            updatepolicies_cors_policy_max_age={updatepolicies_cors_policy_max_age} policies_cors_policy_max_age={policies_cors_policy_max_age}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"http_transformations_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading policies_div" + idPrefix}>
                  <span className="iag_breadcrumb">Policies : </span><br/>                  <h2>HTTP Transformations Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="The gateway can transform inbound requests from clients before forwarding them to the application or outgoing responses from the application before returning them to the client">
                    <p>The gateway can transform inbound requests from clients before forwarding them to the application or outgoing responses from the application before returning them to the client. Refer to the documentation for information about how to author HTTP transformation rules XSL documents.</p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div policies_div" + idPrefix}>
                <div className= {"iag_form_elem policies_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"policies_http_transformations_postauthn_tooltip_id" + idPrefix} >Postauthn</h3><hr/>
</div>
          <ReactTooltip id={"policies_http_transformations_postauthn_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>This node defines the transformations which will take place on requests after authentication has been completed. This entry is  an array and can be used to specify multiple transformations.<br/></div></ReactTooltip>

                <div id={"policies_http_transformations_postauthnTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem policies_div" + idPrefix}>
                    <DataTable id={"policies_http_transformations_postauthnTable" + idPrefix} isSortable
                        headers={policies_http_transformations_postauthnheaderData}
                        rows={policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {policies_http_transformations_postauthnhandleAdd(idPrefix, [setpolicies_http_transformations_postauthn_host(''),    setpolicies_http_transformations_postauthn_name(''),    setpolicies_http_transformations_postauthn_name_valid(true),    setpolicies_http_transformations_postauthn_rule(''),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieshttpTransformationspostauthnDeleteModal row={row} loadGrid={policies_http_transformations_postauthnloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieshttpTransformationspostauthnEdit  data={policies_http_transformations_postauthnrowData.policies_http_transformations_postauthn} setData={setDataMain} row={row} loadGrid={policies_http_transformations_postauthnloadGrid} dataLoad={dataLoad} editing={true} name={"policies_http_transformations_postauthn"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_http_transformations_postauthn_host={updatepolicies_http_transformations_postauthn_host} policies_http_transformations_postauthn_host={policies_http_transformations_postauthn_host}
            updatepolicies_http_transformations_postauthn_name={updatepolicies_http_transformations_postauthn_name} policies_http_transformations_postauthn_name={policies_http_transformations_postauthn_name}
            policies_http_transformations_postauthn_name_valid={policies_http_transformations_postauthn_name_valid}
            policies_http_transformations_postauthn_name_invalid_text={policies_http_transformations_postauthn_name_invalid_text}
            updatepolicies_http_transformations_postauthn_rule={updatepolicies_http_transformations_postauthn_rule} policies_http_transformations_postauthn_rule={policies_http_transformations_postauthn_rule}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem policies_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"policies_http_transformations_postazn_tooltip_id" + idPrefix} >Postazn</h3><hr/>
</div>
          <ReactTooltip id={"policies_http_transformations_postazn_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>This node defines the transformations which will take place on requests after authorization has been completed. This entry is  an array and can be used to specify multiple transformations.<br/></div></ReactTooltip>

                <div id={"policies_http_transformations_postaznTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem policies_div" + idPrefix}>
                    <DataTable id={"policies_http_transformations_postaznTable" + idPrefix} isSortable
                        headers={policies_http_transformations_postaznheaderData}
                        rows={policies_http_transformations_postaznrowData.policies_http_transformations_postazn}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {policies_http_transformations_postaznhandleAdd(idPrefix, [setpolicies_http_transformations_postazn_host(''),    setpolicies_http_transformations_postazn_method(''),    setpolicies_http_transformations_postazn_name(''),    setpolicies_http_transformations_postazn_name_valid(true),    setpolicies_http_transformations_postazn_rule(''),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieshttpTransformationspostaznDeleteModal row={row} loadGrid={policies_http_transformations_postaznloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieshttpTransformationspostaznEdit  data={policies_http_transformations_postaznrowData.policies_http_transformations_postazn} setData={setDataMain} row={row} loadGrid={policies_http_transformations_postaznloadGrid} dataLoad={dataLoad} editing={true} name={"policies_http_transformations_postazn"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_http_transformations_postazn_host={updatepolicies_http_transformations_postazn_host} policies_http_transformations_postazn_host={policies_http_transformations_postazn_host}
            updatepolicies_http_transformations_postazn_method={updatepolicies_http_transformations_postazn_method} policies_http_transformations_postazn_method={policies_http_transformations_postazn_method}
            updatepolicies_http_transformations_postazn_name={updatepolicies_http_transformations_postazn_name} policies_http_transformations_postazn_name={policies_http_transformations_postazn_name}
            policies_http_transformations_postazn_name_valid={policies_http_transformations_postazn_name_valid}
            policies_http_transformations_postazn_name_invalid_text={policies_http_transformations_postazn_name_invalid_text}
            updatepolicies_http_transformations_postazn_rule={updatepolicies_http_transformations_postazn_rule} policies_http_transformations_postazn_rule={policies_http_transformations_postazn_rule}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem policies_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"policies_http_transformations_preazn_tooltip_id" + idPrefix} >Preazn</h3><hr/>
</div>
          <ReactTooltip id={"policies_http_transformations_preazn_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>This node defines the transformations which will take place on requests before authorization has been completed. This entry is  an array and can be used to specify multiple transformations.<br/></div></ReactTooltip>

                <div id={"policies_http_transformations_preaznTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem policies_div" + idPrefix}>
                    <DataTable id={"policies_http_transformations_preaznTable" + idPrefix} isSortable
                        headers={policies_http_transformations_preaznheaderData}
                        rows={policies_http_transformations_preaznrowData.policies_http_transformations_preazn}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {policies_http_transformations_preaznhandleAdd(idPrefix, [setpolicies_http_transformations_preazn_host(''),    setpolicies_http_transformations_preazn_method(''),    setpolicies_http_transformations_preazn_name(''),    setpolicies_http_transformations_preazn_name_valid(true),    setpolicies_http_transformations_preazn_rule(''),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieshttpTransformationspreaznDeleteModal row={row} loadGrid={policies_http_transformations_preaznloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieshttpTransformationspreaznEdit  data={policies_http_transformations_preaznrowData.policies_http_transformations_preazn} setData={setDataMain} row={row} loadGrid={policies_http_transformations_preaznloadGrid} dataLoad={dataLoad} editing={true} name={"policies_http_transformations_preazn"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_http_transformations_preazn_host={updatepolicies_http_transformations_preazn_host} policies_http_transformations_preazn_host={policies_http_transformations_preazn_host}
            updatepolicies_http_transformations_preazn_method={updatepolicies_http_transformations_preazn_method} policies_http_transformations_preazn_method={policies_http_transformations_preazn_method}
            updatepolicies_http_transformations_preazn_name={updatepolicies_http_transformations_preazn_name} policies_http_transformations_preazn_name={policies_http_transformations_preazn_name}
            policies_http_transformations_preazn_name_valid={policies_http_transformations_preazn_name_valid}
            policies_http_transformations_preazn_name_invalid_text={policies_http_transformations_preazn_name_invalid_text}
            updatepolicies_http_transformations_preazn_rule={updatepolicies_http_transformations_preazn_rule} policies_http_transformations_preazn_rule={policies_http_transformations_preazn_rule}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem policies_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"policies_http_transformations_request_tooltip_id" + idPrefix} >Request</h3><hr/>
</div>
          <ReactTooltip id={"policies_http_transformations_request_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>This node defines the transformations which will take place on requests. This entry is an array and can be used to specify multiple transformations.<br/></div></ReactTooltip>

                <div id={"policies_http_transformations_requestTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem policies_div" + idPrefix}>
                    <DataTable id={"policies_http_transformations_requestTable" + idPrefix} isSortable
                        headers={policies_http_transformations_requestheaderData}
                        rows={policies_http_transformations_requestrowData.policies_http_transformations_request}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {policies_http_transformations_requesthandleAdd(idPrefix, [setpolicies_http_transformations_request_host(''),    setpolicies_http_transformations_request_method(''),    setpolicies_http_transformations_request_name(''),    setpolicies_http_transformations_request_name_valid(true),    setpolicies_http_transformations_request_rule(''),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieshttpTransformationsrequestDeleteModal row={row} loadGrid={policies_http_transformations_requestloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieshttpTransformationsrequestEdit  data={policies_http_transformations_requestrowData.policies_http_transformations_request} setData={setDataMain} row={row} loadGrid={policies_http_transformations_requestloadGrid} dataLoad={dataLoad} editing={true} name={"policies_http_transformations_request"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_http_transformations_request_host={updatepolicies_http_transformations_request_host} policies_http_transformations_request_host={policies_http_transformations_request_host}
            updatepolicies_http_transformations_request_method={updatepolicies_http_transformations_request_method} policies_http_transformations_request_method={policies_http_transformations_request_method}
            updatepolicies_http_transformations_request_name={updatepolicies_http_transformations_request_name} policies_http_transformations_request_name={policies_http_transformations_request_name}
            policies_http_transformations_request_name_valid={policies_http_transformations_request_name_valid}
            policies_http_transformations_request_name_invalid_text={policies_http_transformations_request_name_invalid_text}
            updatepolicies_http_transformations_request_rule={updatepolicies_http_transformations_request_rule} policies_http_transformations_request_rule={policies_http_transformations_request_rule}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem policies_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"policies_http_transformations_response_tooltip_id" + idPrefix} >Response</h3><hr/>
</div>
          <ReactTooltip id={"policies_http_transformations_response_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>This node defines the transformations which will take place on responses. This entry is an array and can be used to specify multiple transformations.<br/></div></ReactTooltip>

                <div id={"policies_http_transformations_responseTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem policies_div" + idPrefix}>
                    <DataTable id={"policies_http_transformations_responseTable" + idPrefix} isSortable
                        headers={policies_http_transformations_responseheaderData}
                        rows={policies_http_transformations_responserowData.policies_http_transformations_response}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {policies_http_transformations_responsehandleAdd(idPrefix, [setpolicies_http_transformations_response_host(''),    setpolicies_http_transformations_response_method(''),    setpolicies_http_transformations_response_name(''),    setpolicies_http_transformations_response_name_valid(true),    setpolicies_http_transformations_response_rule(''),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieshttpTransformationsresponseDeleteModal row={row} loadGrid={policies_http_transformations_responseloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieshttpTransformationsresponseEdit  data={policies_http_transformations_responserowData.policies_http_transformations_response} setData={setDataMain} row={row} loadGrid={policies_http_transformations_responseloadGrid} dataLoad={dataLoad} editing={true} name={"policies_http_transformations_response"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_http_transformations_response_host={updatepolicies_http_transformations_response_host} policies_http_transformations_response_host={policies_http_transformations_response_host}
            updatepolicies_http_transformations_response_method={updatepolicies_http_transformations_response_method} policies_http_transformations_response_method={policies_http_transformations_response_method}
            updatepolicies_http_transformations_response_name={updatepolicies_http_transformations_response_name} policies_http_transformations_response_name={policies_http_transformations_response_name}
            policies_http_transformations_response_name_valid={policies_http_transformations_response_name_valid}
            policies_http_transformations_response_name_invalid_text={policies_http_transformations_response_name_invalid_text}
            updatepolicies_http_transformations_response_rule={updatepolicies_http_transformations_response_rule} policies_http_transformations_response_rule={policies_http_transformations_response_rule}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem policies_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"policies_http_transformations_secrets_tooltip_id" + idPrefix} >Secrets</h3><hr/>
</div>
          <ReactTooltip id={"policies_http_transformations_secrets_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>This node contains secrets which can be loaded in Lua HTTP  Transformation rules.<br/>The secret values can be loaded using the `Control.getConfig` method, passing a nil value for the first parameter and the secret name for the second parameter.<br/>For example, the following Lua snippet loads the value of a  secret named "serviceApiKey":<br/>``` value = Control.getConfig(nil, "serviceApiKey") ```<br/></div></ReactTooltip>

                <div id={"policies_http_transformations_secretsTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem policies_div" + idPrefix}>
                    <DataTable id={"policies_http_transformations_secretsTable" + idPrefix} isSortable
                        headers={policies_http_transformations_secretsheaderData}
                        rows={policies_http_transformations_secretsrowData.policies_http_transformations_secrets}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {policies_http_transformations_secretshandleAdd(idPrefix, [setpolicies_http_transformations_secrets_name(''),    setpolicies_http_transformations_secrets_name_valid(true),    setpolicies_http_transformations_secrets_value(''),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieshttpTransformationssecretsDeleteModal row={row} loadGrid={policies_http_transformations_secretsloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieshttpTransformationssecretsEdit  data={policies_http_transformations_secretsrowData.policies_http_transformations_secrets} setData={setDataMain} row={row} loadGrid={policies_http_transformations_secretsloadGrid} dataLoad={dataLoad} editing={true} name={"policies_http_transformations_secrets"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_http_transformations_secrets_name={updatepolicies_http_transformations_secrets_name} policies_http_transformations_secrets_name={policies_http_transformations_secrets_name}
            policies_http_transformations_secrets_name_valid={policies_http_transformations_secrets_name_valid}
            policies_http_transformations_secrets_name_invalid_text={policies_http_transformations_secrets_name_invalid_text}
            updatepolicies_http_transformations_secrets_value={updatepolicies_http_transformations_secrets_value} policies_http_transformations_secrets_value={policies_http_transformations_secrets_value}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"content_injection_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading policies_div" + idPrefix}>
                  <span className="iag_breadcrumb">Policies : </span><br/>                  <h2>Content Injection Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div policies_div" + idPrefix}>
                <div className= {"iag_form_elem policies_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"policies_content_injection_tooltip_id" + idPrefix} >Content Injection</h3><hr/>
</div>
          <ReactTooltip id={"policies_content_injection_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The gateway can inject content into responses. This entry defines the content and when injection should take place. Content injection is performed based on the request path and a specific location within the response.<br/>This entry is an array and can define multiple content injection points.<br/></div></ReactTooltip>

                <div id={"policies_content_injectionTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem policies_div" + idPrefix}>
                    <DataTable id={"policies_content_injectionTable" + idPrefix} isSortable
                        headers={policies_content_injectionheaderData}
                        rows={policies_content_injectionrowData.policies_content_injection}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {policies_content_injectionhandleAdd(idPrefix, [setpolicies_content_injection_content(''),    setpolicies_content_injection_full_line_match(true),    setpolicies_content_injection_location(''),    setpolicies_content_injection_name(''),    setpolicies_content_injection_name_valid(true),    setpolicies_content_injection_replace_match(false),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <PoliciescontentInjectionDeleteModal row={row} loadGrid={policies_content_injectionloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <PoliciescontentInjectionEdit  data={policies_content_injectionrowData.policies_content_injection} setData={setDataMain} row={row} loadGrid={policies_content_injectionloadGrid} dataLoad={dataLoad} editing={true} name={"policies_content_injection"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_content_injection_content={updatepolicies_content_injection_content} policies_content_injection_content={policies_content_injection_content}
            updatepolicies_content_injection_full_line_match={updatepolicies_content_injection_full_line_match} policies_content_injection_full_line_match={policies_content_injection_full_line_match}
            updatepolicies_content_injection_location={updatepolicies_content_injection_location} policies_content_injection_location={policies_content_injection_location}
            updatepolicies_content_injection_name={updatepolicies_content_injection_name} policies_content_injection_name={policies_content_injection_name}
            policies_content_injection_name_valid={policies_content_injection_name_valid}
            policies_content_injection_name_invalid_text={policies_content_injection_name_invalid_text}
            updatepolicies_content_injection_replace_match={updatepolicies_content_injection_replace_match} policies_content_injection_replace_match={policies_content_injection_replace_match}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"waf_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading policies_div" + idPrefix}>
                  <span className="iag_breadcrumb">Policies : </span><br/>                  <h2>Web Application Firewall Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="The gateway can act as a Web Application Firewall using the ModSecurity engine">
                    <p>The gateway can act as a Web Application Firewall using the ModSecurity engine.<br/>The Web Application Firewall policy must at a minimum contain:<br/>  * configuration<br/>  * rules<br/><br/>If there are no request_match entries defined, the WAF will only be active when the Control.triggerWAF function has been called from  within a Lua HTTP Transformation. </p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div policies_div" + idPrefix}>
                <div className= {"iag_form_elem policies_div" + idPrefix}>
  <h3>Configuration</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem policies_div" + idPrefix}>
          <TextInput  value={policies_waf_configuration_content}  id={"policies_waf_configuration_content_id" + idPrefix}  data-tooltip-id={"policies_waf_configuration_content_tooltip_id" + idPrefix}  labelText="Content" onChange={(evt) => { updatepolicies_waf_configuration_content(evt); handleChange(); }}/>
          <ReactTooltip id={"policies_waf_configuration_content_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The content which will be used for configuring the ModSecurity  engine.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem policies_div" + idPrefix}>
                <Select
                  value={policies_waf_configuration_type}
                   id={"policies_waf_configuration_type_id" + idPrefix}
 data-tooltip-id={"policies_waf_configuration_type_tooltip_id" + idPrefix}                   labelText="Type"
                  onChange={(evt) => { updatepolicies_waf_configuration_type(evt); handleChange(); }}>
                  <SelectItem text="" value="" />
                  <SelectItem text="zip" value="zip" />
                  <SelectItem text="path" value="path" />
                </Select>
          <ReactTooltip id={"policies_waf_configuration_type_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The type of content which is being supplied.  Either a zip  file or a directory name.<br/></div></ReactTooltip>
                </div>

                </div>

                <div className= {"iag_form_elem policies_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"policies_waf_request_match_tooltip_id" + idPrefix} >Request Match</h3><hr/>
</div>
          <ReactTooltip id={"policies_waf_request_match_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>This entry defines a list of request matches for which the Web  Application Firewall will be run.<br/>Each defined request match must contain at least:<br/>  * method<br/>  * path<br/></div></ReactTooltip>

                <div id={"policies_waf_request_matchTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem policies_div" + idPrefix}>
                    <DataTable id={"policies_waf_request_matchTable" + idPrefix} isSortable
                        headers={policies_waf_request_matchheaderData}
                        rows={policies_waf_request_matchrowData.policies_waf_request_match}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {policies_waf_request_matchhandleAdd(idPrefix, [setpolicies_waf_request_match_method(''),    setpolicies_waf_request_match_method_valid(true),    setpolicies_waf_request_match_path(''),    setpolicies_waf_request_match_path_valid(true),    setpolicies_waf_request_match_phases_logging(true),    setpolicies_waf_request_match_phases_request_body(true),    setpolicies_waf_request_match_phases_request_headers(true),    setpolicies_waf_request_match_phases_response_body(true),    setpolicies_waf_request_match_phases_response_headers(true),    setpolicies_waf_request_match_version('*'),    setpolicies_waf_request_match_version_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieswafrequestMatchDeleteModal row={row} loadGrid={policies_waf_request_matchloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <PolicieswafrequestMatchEdit  data={policies_waf_request_matchrowData.policies_waf_request_match} setData={setDataMain} row={row} loadGrid={policies_waf_request_matchloadGrid} dataLoad={dataLoad} editing={true} name={"policies_waf_request_match"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_waf_request_match_method={updatepolicies_waf_request_match_method} policies_waf_request_match_method={policies_waf_request_match_method}
            policies_waf_request_match_method_valid={policies_waf_request_match_method_valid}
            policies_waf_request_match_method_invalid_text={policies_waf_request_match_method_invalid_text}
            updatepolicies_waf_request_match_path={updatepolicies_waf_request_match_path} policies_waf_request_match_path={policies_waf_request_match_path}
            policies_waf_request_match_path_valid={policies_waf_request_match_path_valid}
            policies_waf_request_match_path_invalid_text={policies_waf_request_match_path_invalid_text}
            updatepolicies_waf_request_match_phases_logging={updatepolicies_waf_request_match_phases_logging} policies_waf_request_match_phases_logging={policies_waf_request_match_phases_logging}
            updatepolicies_waf_request_match_phases_request_body={updatepolicies_waf_request_match_phases_request_body} policies_waf_request_match_phases_request_body={policies_waf_request_match_phases_request_body}
            updatepolicies_waf_request_match_phases_request_headers={updatepolicies_waf_request_match_phases_request_headers} policies_waf_request_match_phases_request_headers={policies_waf_request_match_phases_request_headers}
            updatepolicies_waf_request_match_phases_response_body={updatepolicies_waf_request_match_phases_response_body} policies_waf_request_match_phases_response_body={policies_waf_request_match_phases_response_body}
            updatepolicies_waf_request_match_phases_response_headers={updatepolicies_waf_request_match_phases_response_headers} policies_waf_request_match_phases_response_headers={policies_waf_request_match_phases_response_headers}
            updatepolicies_waf_request_match_version={updatepolicies_waf_request_match_version} policies_waf_request_match_version={policies_waf_request_match_version}
            policies_waf_request_match_version_valid={policies_waf_request_match_version_valid}
            policies_waf_request_match_version_invalid_text={policies_waf_request_match_version_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem policies_div" + idPrefix}>
  <h3>Rules</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem policies_div" + idPrefix}>
          <TextInput  value={policies_waf_rules_content}  id={"policies_waf_rules_content_id" + idPrefix}  data-tooltip-id={"policies_waf_rules_content_tooltip_id" + idPrefix}  labelText="Content" onChange={(evt) => { updatepolicies_waf_rules_content(evt); handleChange(); }}/>
          <ReactTooltip id={"policies_waf_rules_content_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The content which will be used as rules for the ModSecurity  engine.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem policies_div" + idPrefix}>
                <Select
                  value={policies_waf_rules_type}
                   id={"policies_waf_rules_type_id" + idPrefix}
 data-tooltip-id={"policies_waf_rules_type_tooltip_id" + idPrefix}                   labelText="Type"
                  onChange={(evt) => { updatepolicies_waf_rules_type(evt); handleChange(); }}>
                  <SelectItem text="" value="" />
                  <SelectItem text="zip" value="zip" />
                  <SelectItem text="path" value="path" />
                </Select>
          <ReactTooltip id={"policies_waf_rules_type_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The type of content which is being supplied.  Either a zip  file or a directory name.<br/></div></ReactTooltip>
                </div>

                </div>

                </div>
              </TabPanel>
            </Tabs>
                  <Suspense fallback={<div></div>}>
                    <PoliciesauthorizationAdd loadGrid={policies_authorizationloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatepolicies_authorization_action={updatepolicies_authorization_action} policies_authorization_action={policies_authorization_action}
            updatepolicies_authorization_host={updatepolicies_authorization_host} policies_authorization_host={policies_authorization_host}
            updatepolicies_authorization_name={updatepolicies_authorization_name} policies_authorization_name={policies_authorization_name}
            policies_authorization_name_valid={policies_authorization_name_valid}
            policies_authorization_name_invalid_text={policies_authorization_name_invalid_text}
            updatepolicies_authorization_obligation_oidc_acr_values={updatepolicies_authorization_obligation_oidc_acr_values} policies_authorization_obligation_oidc_acr_values={policies_authorization_obligation_oidc_acr_values}
            updatepolicies_authorization_obligation_oidc_max_age={updatepolicies_authorization_obligation_oidc_max_age} policies_authorization_obligation_oidc_max_age={policies_authorization_obligation_oidc_max_age}
            updatepolicies_authorization_obligation_oidc_prompt={updatepolicies_authorization_obligation_oidc_prompt} policies_authorization_obligation_oidc_prompt={policies_authorization_obligation_oidc_prompt}
            updatepolicies_authorization_obligation_redirect_url={updatepolicies_authorization_obligation_redirect_url} policies_authorization_obligation_redirect_url={policies_authorization_obligation_redirect_url}
            updatepolicies_authorization_rule={updatepolicies_authorization_rule} policies_authorization_rule={policies_authorization_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PoliciesauthorizationEdit  loadGrid={policies_authorizationloadGrid} dataLoad={dataLoad} name={"policies_authorization"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_authorization_action={updatepolicies_authorization_action} policies_authorization_action={policies_authorization_action}
            updatepolicies_authorization_host={updatepolicies_authorization_host} policies_authorization_host={policies_authorization_host}
            updatepolicies_authorization_name={updatepolicies_authorization_name} policies_authorization_name={policies_authorization_name}
            policies_authorization_name_valid={policies_authorization_name_valid}
            policies_authorization_name_invalid_text={policies_authorization_name_invalid_text}
            updatepolicies_authorization_obligation_oidc_acr_values={updatepolicies_authorization_obligation_oidc_acr_values} policies_authorization_obligation_oidc_acr_values={policies_authorization_obligation_oidc_acr_values}
            updatepolicies_authorization_obligation_oidc_max_age={updatepolicies_authorization_obligation_oidc_max_age} policies_authorization_obligation_oidc_max_age={policies_authorization_obligation_oidc_max_age}
            updatepolicies_authorization_obligation_oidc_prompt={updatepolicies_authorization_obligation_oidc_prompt} policies_authorization_obligation_oidc_prompt={policies_authorization_obligation_oidc_prompt}
            updatepolicies_authorization_obligation_redirect_url={updatepolicies_authorization_obligation_redirect_url} policies_authorization_obligation_redirect_url={policies_authorization_obligation_redirect_url}
            updatepolicies_authorization_rule={updatepolicies_authorization_rule} policies_authorization_rule={policies_authorization_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PoliciescontentInjectionAdd loadGrid={policies_content_injectionloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatepolicies_content_injection_content={updatepolicies_content_injection_content} policies_content_injection_content={policies_content_injection_content}
            updatepolicies_content_injection_full_line_match={updatepolicies_content_injection_full_line_match} policies_content_injection_full_line_match={policies_content_injection_full_line_match}
            updatepolicies_content_injection_location={updatepolicies_content_injection_location} policies_content_injection_location={policies_content_injection_location}
            updatepolicies_content_injection_name={updatepolicies_content_injection_name} policies_content_injection_name={policies_content_injection_name}
            policies_content_injection_name_valid={policies_content_injection_name_valid}
            policies_content_injection_name_invalid_text={policies_content_injection_name_invalid_text}
            updatepolicies_content_injection_replace_match={updatepolicies_content_injection_replace_match} policies_content_injection_replace_match={policies_content_injection_replace_match}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PoliciescontentInjectionEdit  loadGrid={policies_content_injectionloadGrid} dataLoad={dataLoad} name={"policies_content_injection"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_content_injection_content={updatepolicies_content_injection_content} policies_content_injection_content={policies_content_injection_content}
            updatepolicies_content_injection_full_line_match={updatepolicies_content_injection_full_line_match} policies_content_injection_full_line_match={policies_content_injection_full_line_match}
            updatepolicies_content_injection_location={updatepolicies_content_injection_location} policies_content_injection_location={policies_content_injection_location}
            updatepolicies_content_injection_name={updatepolicies_content_injection_name} policies_content_injection_name={policies_content_injection_name}
            policies_content_injection_name_valid={policies_content_injection_name_valid}
            policies_content_injection_name_invalid_text={policies_content_injection_name_invalid_text}
            updatepolicies_content_injection_replace_match={updatepolicies_content_injection_replace_match} policies_content_injection_replace_match={policies_content_injection_replace_match}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PoliciescorsAdd loadGrid={policies_corsloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatepolicies_cors_host={updatepolicies_cors_host} policies_cors_host={policies_cors_host}
            updatepolicies_cors_method={updatepolicies_cors_method} policies_cors_method={policies_cors_method}
            updatepolicies_cors_name={updatepolicies_cors_name} policies_cors_name={policies_cors_name}
            policies_cors_name_valid={policies_cors_name_valid}
            policies_cors_name_invalid_text={policies_cors_name_invalid_text}
            updatepolicies_cors_policy_allow_credentials={updatepolicies_cors_policy_allow_credentials} policies_cors_policy_allow_credentials={policies_cors_policy_allow_credentials}
            updatepolicies_cors_policy_handle_pre_flight={updatepolicies_cors_policy_handle_pre_flight} policies_cors_policy_handle_pre_flight={policies_cors_policy_handle_pre_flight}
            updatepolicies_cors_policy_max_age={updatepolicies_cors_policy_max_age} policies_cors_policy_max_age={policies_cors_policy_max_age}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PoliciescorsEdit  loadGrid={policies_corsloadGrid} dataLoad={dataLoad} name={"policies_cors"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_cors_host={updatepolicies_cors_host} policies_cors_host={policies_cors_host}
            updatepolicies_cors_method={updatepolicies_cors_method} policies_cors_method={policies_cors_method}
            updatepolicies_cors_name={updatepolicies_cors_name} policies_cors_name={policies_cors_name}
            policies_cors_name_valid={policies_cors_name_valid}
            policies_cors_name_invalid_text={policies_cors_name_invalid_text}
            updatepolicies_cors_policy_allow_credentials={updatepolicies_cors_policy_allow_credentials} policies_cors_policy_allow_credentials={policies_cors_policy_allow_credentials}
            updatepolicies_cors_policy_handle_pre_flight={updatepolicies_cors_policy_handle_pre_flight} policies_cors_policy_handle_pre_flight={policies_cors_policy_handle_pre_flight}
            updatepolicies_cors_policy_max_age={updatepolicies_cors_policy_max_age} policies_cors_policy_max_age={policies_cors_policy_max_age}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieshttpTransformationspostauthnAdd loadGrid={policies_http_transformations_postauthnloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatepolicies_http_transformations_postauthn_host={updatepolicies_http_transformations_postauthn_host} policies_http_transformations_postauthn_host={policies_http_transformations_postauthn_host}
            updatepolicies_http_transformations_postauthn_name={updatepolicies_http_transformations_postauthn_name} policies_http_transformations_postauthn_name={policies_http_transformations_postauthn_name}
            policies_http_transformations_postauthn_name_valid={policies_http_transformations_postauthn_name_valid}
            policies_http_transformations_postauthn_name_invalid_text={policies_http_transformations_postauthn_name_invalid_text}
            updatepolicies_http_transformations_postauthn_rule={updatepolicies_http_transformations_postauthn_rule} policies_http_transformations_postauthn_rule={policies_http_transformations_postauthn_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieshttpTransformationspostauthnEdit  loadGrid={policies_http_transformations_postauthnloadGrid} dataLoad={dataLoad} name={"policies_http_transformations_postauthn"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_http_transformations_postauthn_host={updatepolicies_http_transformations_postauthn_host} policies_http_transformations_postauthn_host={policies_http_transformations_postauthn_host}
            updatepolicies_http_transformations_postauthn_name={updatepolicies_http_transformations_postauthn_name} policies_http_transformations_postauthn_name={policies_http_transformations_postauthn_name}
            policies_http_transformations_postauthn_name_valid={policies_http_transformations_postauthn_name_valid}
            policies_http_transformations_postauthn_name_invalid_text={policies_http_transformations_postauthn_name_invalid_text}
            updatepolicies_http_transformations_postauthn_rule={updatepolicies_http_transformations_postauthn_rule} policies_http_transformations_postauthn_rule={policies_http_transformations_postauthn_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieshttpTransformationspostaznAdd loadGrid={policies_http_transformations_postaznloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatepolicies_http_transformations_postazn_host={updatepolicies_http_transformations_postazn_host} policies_http_transformations_postazn_host={policies_http_transformations_postazn_host}
            updatepolicies_http_transformations_postazn_method={updatepolicies_http_transformations_postazn_method} policies_http_transformations_postazn_method={policies_http_transformations_postazn_method}
            updatepolicies_http_transformations_postazn_name={updatepolicies_http_transformations_postazn_name} policies_http_transformations_postazn_name={policies_http_transformations_postazn_name}
            policies_http_transformations_postazn_name_valid={policies_http_transformations_postazn_name_valid}
            policies_http_transformations_postazn_name_invalid_text={policies_http_transformations_postazn_name_invalid_text}
            updatepolicies_http_transformations_postazn_rule={updatepolicies_http_transformations_postazn_rule} policies_http_transformations_postazn_rule={policies_http_transformations_postazn_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieshttpTransformationspostaznEdit  loadGrid={policies_http_transformations_postaznloadGrid} dataLoad={dataLoad} name={"policies_http_transformations_postazn"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_http_transformations_postazn_host={updatepolicies_http_transformations_postazn_host} policies_http_transformations_postazn_host={policies_http_transformations_postazn_host}
            updatepolicies_http_transformations_postazn_method={updatepolicies_http_transformations_postazn_method} policies_http_transformations_postazn_method={policies_http_transformations_postazn_method}
            updatepolicies_http_transformations_postazn_name={updatepolicies_http_transformations_postazn_name} policies_http_transformations_postazn_name={policies_http_transformations_postazn_name}
            policies_http_transformations_postazn_name_valid={policies_http_transformations_postazn_name_valid}
            policies_http_transformations_postazn_name_invalid_text={policies_http_transformations_postazn_name_invalid_text}
            updatepolicies_http_transformations_postazn_rule={updatepolicies_http_transformations_postazn_rule} policies_http_transformations_postazn_rule={policies_http_transformations_postazn_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieshttpTransformationspreaznAdd loadGrid={policies_http_transformations_preaznloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatepolicies_http_transformations_preazn_host={updatepolicies_http_transformations_preazn_host} policies_http_transformations_preazn_host={policies_http_transformations_preazn_host}
            updatepolicies_http_transformations_preazn_method={updatepolicies_http_transformations_preazn_method} policies_http_transformations_preazn_method={policies_http_transformations_preazn_method}
            updatepolicies_http_transformations_preazn_name={updatepolicies_http_transformations_preazn_name} policies_http_transformations_preazn_name={policies_http_transformations_preazn_name}
            policies_http_transformations_preazn_name_valid={policies_http_transformations_preazn_name_valid}
            policies_http_transformations_preazn_name_invalid_text={policies_http_transformations_preazn_name_invalid_text}
            updatepolicies_http_transformations_preazn_rule={updatepolicies_http_transformations_preazn_rule} policies_http_transformations_preazn_rule={policies_http_transformations_preazn_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieshttpTransformationspreaznEdit  loadGrid={policies_http_transformations_preaznloadGrid} dataLoad={dataLoad} name={"policies_http_transformations_preazn"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_http_transformations_preazn_host={updatepolicies_http_transformations_preazn_host} policies_http_transformations_preazn_host={policies_http_transformations_preazn_host}
            updatepolicies_http_transformations_preazn_method={updatepolicies_http_transformations_preazn_method} policies_http_transformations_preazn_method={policies_http_transformations_preazn_method}
            updatepolicies_http_transformations_preazn_name={updatepolicies_http_transformations_preazn_name} policies_http_transformations_preazn_name={policies_http_transformations_preazn_name}
            policies_http_transformations_preazn_name_valid={policies_http_transformations_preazn_name_valid}
            policies_http_transformations_preazn_name_invalid_text={policies_http_transformations_preazn_name_invalid_text}
            updatepolicies_http_transformations_preazn_rule={updatepolicies_http_transformations_preazn_rule} policies_http_transformations_preazn_rule={policies_http_transformations_preazn_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieshttpTransformationsrequestAdd loadGrid={policies_http_transformations_requestloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatepolicies_http_transformations_request_host={updatepolicies_http_transformations_request_host} policies_http_transformations_request_host={policies_http_transformations_request_host}
            updatepolicies_http_transformations_request_method={updatepolicies_http_transformations_request_method} policies_http_transformations_request_method={policies_http_transformations_request_method}
            updatepolicies_http_transformations_request_name={updatepolicies_http_transformations_request_name} policies_http_transformations_request_name={policies_http_transformations_request_name}
            policies_http_transformations_request_name_valid={policies_http_transformations_request_name_valid}
            policies_http_transformations_request_name_invalid_text={policies_http_transformations_request_name_invalid_text}
            updatepolicies_http_transformations_request_rule={updatepolicies_http_transformations_request_rule} policies_http_transformations_request_rule={policies_http_transformations_request_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieshttpTransformationsrequestEdit  loadGrid={policies_http_transformations_requestloadGrid} dataLoad={dataLoad} name={"policies_http_transformations_request"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_http_transformations_request_host={updatepolicies_http_transformations_request_host} policies_http_transformations_request_host={policies_http_transformations_request_host}
            updatepolicies_http_transformations_request_method={updatepolicies_http_transformations_request_method} policies_http_transformations_request_method={policies_http_transformations_request_method}
            updatepolicies_http_transformations_request_name={updatepolicies_http_transformations_request_name} policies_http_transformations_request_name={policies_http_transformations_request_name}
            policies_http_transformations_request_name_valid={policies_http_transformations_request_name_valid}
            policies_http_transformations_request_name_invalid_text={policies_http_transformations_request_name_invalid_text}
            updatepolicies_http_transformations_request_rule={updatepolicies_http_transformations_request_rule} policies_http_transformations_request_rule={policies_http_transformations_request_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieshttpTransformationsresponseAdd loadGrid={policies_http_transformations_responseloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatepolicies_http_transformations_response_host={updatepolicies_http_transformations_response_host} policies_http_transformations_response_host={policies_http_transformations_response_host}
            updatepolicies_http_transformations_response_method={updatepolicies_http_transformations_response_method} policies_http_transformations_response_method={policies_http_transformations_response_method}
            updatepolicies_http_transformations_response_name={updatepolicies_http_transformations_response_name} policies_http_transformations_response_name={policies_http_transformations_response_name}
            policies_http_transformations_response_name_valid={policies_http_transformations_response_name_valid}
            policies_http_transformations_response_name_invalid_text={policies_http_transformations_response_name_invalid_text}
            updatepolicies_http_transformations_response_rule={updatepolicies_http_transformations_response_rule} policies_http_transformations_response_rule={policies_http_transformations_response_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieshttpTransformationsresponseEdit  loadGrid={policies_http_transformations_responseloadGrid} dataLoad={dataLoad} name={"policies_http_transformations_response"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_http_transformations_response_host={updatepolicies_http_transformations_response_host} policies_http_transformations_response_host={policies_http_transformations_response_host}
            updatepolicies_http_transformations_response_method={updatepolicies_http_transformations_response_method} policies_http_transformations_response_method={policies_http_transformations_response_method}
            updatepolicies_http_transformations_response_name={updatepolicies_http_transformations_response_name} policies_http_transformations_response_name={policies_http_transformations_response_name}
            policies_http_transformations_response_name_valid={policies_http_transformations_response_name_valid}
            policies_http_transformations_response_name_invalid_text={policies_http_transformations_response_name_invalid_text}
            updatepolicies_http_transformations_response_rule={updatepolicies_http_transformations_response_rule} policies_http_transformations_response_rule={policies_http_transformations_response_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieshttpTransformationssecretsAdd loadGrid={policies_http_transformations_secretsloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatepolicies_http_transformations_secrets_name={updatepolicies_http_transformations_secrets_name} policies_http_transformations_secrets_name={policies_http_transformations_secrets_name}
            policies_http_transformations_secrets_name_valid={policies_http_transformations_secrets_name_valid}
            policies_http_transformations_secrets_name_invalid_text={policies_http_transformations_secrets_name_invalid_text}
            updatepolicies_http_transformations_secrets_value={updatepolicies_http_transformations_secrets_value} policies_http_transformations_secrets_value={policies_http_transformations_secrets_value}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieshttpTransformationssecretsEdit  loadGrid={policies_http_transformations_secretsloadGrid} dataLoad={dataLoad} name={"policies_http_transformations_secrets"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_http_transformations_secrets_name={updatepolicies_http_transformations_secrets_name} policies_http_transformations_secrets_name={policies_http_transformations_secrets_name}
            policies_http_transformations_secrets_name_valid={policies_http_transformations_secrets_name_valid}
            policies_http_transformations_secrets_name_invalid_text={policies_http_transformations_secrets_name_invalid_text}
            updatepolicies_http_transformations_secrets_value={updatepolicies_http_transformations_secrets_value} policies_http_transformations_secrets_value={policies_http_transformations_secrets_value}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PoliciesrateLimitingAdd loadGrid={policies_rate_limitingloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatepolicies_rate_limiting_name={updatepolicies_rate_limiting_name} policies_rate_limiting_name={policies_rate_limiting_name}
            policies_rate_limiting_name_valid={policies_rate_limiting_name_valid}
            policies_rate_limiting_name_invalid_text={policies_rate_limiting_name_invalid_text}
            updatepolicies_rate_limiting_rule={updatepolicies_rate_limiting_rule} policies_rate_limiting_rule={policies_rate_limiting_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PoliciesrateLimitingEdit  loadGrid={policies_rate_limitingloadGrid} dataLoad={dataLoad} name={"policies_rate_limiting"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_rate_limiting_name={updatepolicies_rate_limiting_name} policies_rate_limiting_name={policies_rate_limiting_name}
            policies_rate_limiting_name_valid={policies_rate_limiting_name_valid}
            policies_rate_limiting_name_invalid_text={policies_rate_limiting_name_invalid_text}
            updatepolicies_rate_limiting_rule={updatepolicies_rate_limiting_rule} policies_rate_limiting_rule={policies_rate_limiting_rule}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieswafrequestMatchAdd loadGrid={policies_waf_request_matchloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updatepolicies_waf_request_match_method={updatepolicies_waf_request_match_method} policies_waf_request_match_method={policies_waf_request_match_method}
            policies_waf_request_match_method_valid={policies_waf_request_match_method_valid}
            policies_waf_request_match_method_invalid_text={policies_waf_request_match_method_invalid_text}
            updatepolicies_waf_request_match_path={updatepolicies_waf_request_match_path} policies_waf_request_match_path={policies_waf_request_match_path}
            policies_waf_request_match_path_valid={policies_waf_request_match_path_valid}
            policies_waf_request_match_path_invalid_text={policies_waf_request_match_path_invalid_text}
            updatepolicies_waf_request_match_phases_logging={updatepolicies_waf_request_match_phases_logging} policies_waf_request_match_phases_logging={policies_waf_request_match_phases_logging}
            updatepolicies_waf_request_match_phases_request_body={updatepolicies_waf_request_match_phases_request_body} policies_waf_request_match_phases_request_body={policies_waf_request_match_phases_request_body}
            updatepolicies_waf_request_match_phases_request_headers={updatepolicies_waf_request_match_phases_request_headers} policies_waf_request_match_phases_request_headers={policies_waf_request_match_phases_request_headers}
            updatepolicies_waf_request_match_phases_response_body={updatepolicies_waf_request_match_phases_response_body} policies_waf_request_match_phases_response_body={policies_waf_request_match_phases_response_body}
            updatepolicies_waf_request_match_phases_response_headers={updatepolicies_waf_request_match_phases_response_headers} policies_waf_request_match_phases_response_headers={policies_waf_request_match_phases_response_headers}
            updatepolicies_waf_request_match_version={updatepolicies_waf_request_match_version} policies_waf_request_match_version={policies_waf_request_match_version}
            policies_waf_request_match_version_valid={policies_waf_request_match_version_valid}
            policies_waf_request_match_version_invalid_text={policies_waf_request_match_version_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <PolicieswafrequestMatchEdit  loadGrid={policies_waf_request_matchloadGrid} dataLoad={dataLoad} name={"policies_waf_request_match"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updatepolicies_waf_request_match_method={updatepolicies_waf_request_match_method} policies_waf_request_match_method={policies_waf_request_match_method}
            policies_waf_request_match_method_valid={policies_waf_request_match_method_valid}
            policies_waf_request_match_method_invalid_text={policies_waf_request_match_method_invalid_text}
            updatepolicies_waf_request_match_path={updatepolicies_waf_request_match_path} policies_waf_request_match_path={policies_waf_request_match_path}
            policies_waf_request_match_path_valid={policies_waf_request_match_path_valid}
            policies_waf_request_match_path_invalid_text={policies_waf_request_match_path_invalid_text}
            updatepolicies_waf_request_match_phases_logging={updatepolicies_waf_request_match_phases_logging} policies_waf_request_match_phases_logging={policies_waf_request_match_phases_logging}
            updatepolicies_waf_request_match_phases_request_body={updatepolicies_waf_request_match_phases_request_body} policies_waf_request_match_phases_request_body={policies_waf_request_match_phases_request_body}
            updatepolicies_waf_request_match_phases_request_headers={updatepolicies_waf_request_match_phases_request_headers} policies_waf_request_match_phases_request_headers={policies_waf_request_match_phases_request_headers}
            updatepolicies_waf_request_match_phases_response_body={updatepolicies_waf_request_match_phases_response_body} policies_waf_request_match_phases_response_body={policies_waf_request_match_phases_response_body}
            updatepolicies_waf_request_match_phases_response_headers={updatepolicies_waf_request_match_phases_response_headers} policies_waf_request_match_phases_response_headers={policies_waf_request_match_phases_response_headers}
            updatepolicies_waf_request_match_version={updatepolicies_waf_request_match_version} policies_waf_request_match_version={policies_waf_request_match_version}
            policies_waf_request_match_version_valid={policies_waf_request_match_version_valid}
            policies_waf_request_match_version_invalid_text={policies_waf_request_match_version_invalid_text}
                    />
                  </Suspense>
              </div>
            </div>
          </div>
        </div>
    );
};
export default PoliciesPage;
